webpackJsonp([1],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return get; });
/* unused harmony export remove */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return post; });
/* unused harmony export put */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store_index__ = __webpack_require__(31);



var requestsTotal = 0;
var requestCompleted = 0;
var postTotal = 0;
var postCompleted = 0;

var get = function get(path, data, cb, errorCb) {
    requestsTotal++;
    __WEBPACK_IMPORTED_MODULE_1__store_index__["a" /* default */].state.loading = true;
    __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].axios.get(path, { params: data }).then(function (response) {
        requestCompleted++;
        loading();
        cb(response);
    }).catch(function (error) {
        requestCompleted++;
        loading();
        errorCb(error);
    });
};

var remove = function remove(path, cb, errorCb) {
    requestsTotal++;
    __WEBPACK_IMPORTED_MODULE_1__store_index__["a" /* default */].state.loading = true;
    __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].axios.delete(path).then(function (response) {
        requestCompleted++;
        loading();
        cb(response);
    }).catch(function (error) {
        requestCompleted++;
        loading();
        if (errorCb !== undefined) {
            errorCb(error.response);
        }
    });
};

var post = function post(path, data, cb, errorCb) {
    postTotal++;
    __WEBPACK_IMPORTED_MODULE_1__store_index__["a" /* default */].state.inputLoading = true;
    __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].axios.post(path, data).then(function (response) {
        postCompleted++;
        PostLoading();
        cb(response);
    }).catch(function (error) {
        postCompleted++;
        PostLoading();
        if (errorCb !== undefined) {
            errorCb(error.response);
        }
    });
};

var put = function put(path, data, cb, errorCb) {
    postTotal++;
    __WEBPACK_IMPORTED_MODULE_1__store_index__["a" /* default */].state.inputLoading = true;
    data['_method'] = 'PUT';
    __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].axios.put(path, data).then(function (response) {
        postCompleted++;
        PostLoading();
        cb(response);
    }).catch(function (error) {
        postCompleted++;
        PostLoading();
        if (errorCb !== undefined) {
            errorCb(error.response);
        }
    });
};

function loading() {
    if (requestsTotal === requestCompleted) {
        requestsTotal = 0;
        requestCompleted = 0;
        __WEBPACK_IMPORTED_MODULE_1__store_index__["a" /* default */].state.loading = false;
    }
}

function PostLoading() {
    if (postTotal === postCompleted) {
        postTotal = 0;
        postCompleted = 0;
        __WEBPACK_IMPORTED_MODULE_1__store_index__["a" /* default */].state.inputLoading = false;
    }
}



/***/ }),
/* 15 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return find; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return findAll; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__HttpService__ = __webpack_require__(14);


var namespace = 'lookups';

var findAll = function findAll(cb, errorCb) {
    __WEBPACK_IMPORTED_MODULE_0__HttpService__["a" /* get */](namespace, cb, errorCb);
};

var find = function find(id, cb, errorCb) {
    __WEBPACK_IMPORTED_MODULE_0__HttpService__["a" /* get */](namespace + '/' + id, cb, errorCb);
};



/***/ }),
/* 16 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return find; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return findAll; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__HttpService__ = __webpack_require__(14);


var namespace = 'vehicles';

var findAll = function findAll(options, cb, errorCb) {
    __WEBPACK_IMPORTED_MODULE_0__HttpService__["a" /* get */](namespace, options, cb, errorCb);
};

var find = function find(id, options, cb, errorCb) {
    __WEBPACK_IMPORTED_MODULE_0__HttpService__["a" /* get */](namespace + '/' + id, options, cb, errorCb);
};



/***/ }),
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(366);



__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
    state: {
        loading: false,
        isLoading: false,
        licenseplate: '',
        vehicleData: null,
        searching: false,
        match: false,
        loadingWanted: false,
        loadingDmr: false,
        loadingInspection: false,
        loadingRegistry: false,
        loadingLookups: false,
        showingResult: false,
        carData: {
            general: null,
            dmr: null,
            registry: null,
            inspection: null,
            lookups: null,
            wanted: null
        }
    },
    modules: {}
}));

/***/ }),
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(364);



__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: 'history',

  routes: [{
    path: '/404',
    name: '404',
    component: __webpack_require__(331)
  }, {
    path: '*',
    redirect: '404'
  }, {
    path: '/opslag/:licenseplate',
    name: 'Lookup',
    component: __webpack_require__(333)
  }, {
    path: '/',
    name: 'Landing',
    component: __webpack_require__(334)
  }, {
    path: '/sammenlign',
    name: 'Compare',
    component: __webpack_require__(332)
  }, {
    path: '/soeg/:licenseplate',
    name: 'Search',
    component: __webpack_require__(338),
    children: [{
      path: 'overblik',
      name: 'SearchOverview',
      component: __webpack_require__(340)
    }, {
      path: 'bilbogen',
      name: 'SearchRegistry',
      component: __webpack_require__(341)
    }, {
      path: 'synsrapporter',
      name: 'SearchReports',
      component: __webpack_require__(342)
    }, {
      path: 'afgifter',
      name: 'SearchCharges',
      component: __webpack_require__(339)
    }, {
      path: 'tidslinje',
      name: 'SearchTimeline',
      component: __webpack_require__(344)
    }, {
      path: 'teknisk-info',
      name: 'SearchTechnicalInfo',
      component: __webpack_require__(343)
    }]
  }]
}));

/***/ }),
/* 189 */,
/* 190 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(306)

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(258),
  /* template */
  __webpack_require__(351),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 195 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(310)

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(259),
  /* template */
  __webpack_require__(355),
  /* scopeId */
  "data-v-74f7059d",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(309)

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(260),
  /* template */
  __webpack_require__(354),
  /* scopeId */
  "data-v-732aedac",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(194);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_axios__ = __webpack_require__(193);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__store__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_moment__ = __webpack_require__(197);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_es6_promise_auto__ = __webpack_require__(189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_es6_promise_auto___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_es6_promise_auto__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_raven_js__ = __webpack_require__(192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_raven_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_raven_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_raven_js_plugins_vue__ = __webpack_require__(191);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_raven_js_plugins_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_raven_js_plugins_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__deveodk_vue_seo__ = __webpack_require__(185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__deveodk_vue_seo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__deveodk_vue_seo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__deveodk_vue_toastr__ = __webpack_require__(186);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__deveodk_vue_toastr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__deveodk_vue_toastr__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__deveodk_vue_toastr_dist_deveodk_vue_toastr_css__ = __webpack_require__(190);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__deveodk_vue_toastr_dist_deveodk_vue_toastr_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__deveodk_vue_toastr_dist_deveodk_vue_toastr_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__deveodk_vue_error_tracker__ = __webpack_require__(181);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__deveodk_vue_error_tracker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__deveodk_vue_error_tracker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__sentry_browser__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__sentry_integrations__ = __webpack_require__(187);











__WEBPACK_IMPORTED_MODULE_8_raven_js___default.a.addPlugin(__WEBPACK_IMPORTED_MODULE_9_raven_js_plugins_vue___default.a, __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]).install();
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.$raven = __WEBPACK_IMPORTED_MODULE_8_raven_js___default.a;


__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_10__deveodk_vue_seo___default.a);

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.$scrollToTop = function () {
    return window.scrollTo(0, 0);
};

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_4_vue_axios___default.a, __WEBPACK_IMPORTED_MODULE_3_axios___default.a);
var API_URL = "https://nodeapi.nrpladetjek.dk" + '/';
__WEBPACK_IMPORTED_MODULE_3_axios___default.a.defaults.baseURL = API_URL;



__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_11__deveodk_vue_toastr___default.a, {
    defaultPosition: 'toast-bottom-right',
    defaultType: 'info',
    defaultTimeout: 5000
});

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].filter('formattedNumber', function (value) {
    if (!value) return '';

    if (value > 999) {
        return Number(value).toFixed(3);
    } else {
        return Number(value).toFixed(0);
    }
});

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].filter('withDecimals', function (value) {
    return Number(value).toFixed(2);
});

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].filter('rounded', function (value) {
    if (!value) return '';
    return value.toFixed(0);
});

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].filter('currency', function (value) {
    var valueInNumbers = value.toString().replace(/\D/g, '');
    var valueWithCommaDecimals = valueInNumbers.replace('.', ',');
    var formattedNumber = valueWithCommaDecimals.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.');
    return formattedNumber;
});

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].filter('thousand', function (value) {
    var formattedNumber = value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    return formattedNumber;
});

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('line-data', __webpack_require__(196));
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('data-loader', __webpack_require__(195));


__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_13__deveodk_vue_error_tracker___default.a, {
    HttpDriver: __webpack_require__(182),
    NotificationDriver: __webpack_require__(183),
    ReportDriver: __webpack_require__(184),
    HttpErrorCodes: {
        401: {
            title: 'Ingen adgang',
            message: 'Du har ikke adgang til at se dette',
            type: 'error'
        },
        400: {
            title: 'Ukendt fejl',
            message: 'Noget gik galt',
            type: 'error'
        },

        500: {
            title: 'Server fejl',
            message: 'Åhh nej noget er gået galt',
            type: 'error'
        }
    }
});

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_6_vue_moment___default.a);
__webpack_require__(19);

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;




if (true) {
    __WEBPACK_IMPORTED_MODULE_14__sentry_browser__["a" /* init */]({
        dsn: 'https://b7e4174463684a81a1a219616a467c92@sentry.io/1493308',
        integrations: [new __WEBPACK_IMPORTED_MODULE_15__sentry_integrations__["a" /* Vue */]({ Vue: __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */], attachProps: true })]
    });
}

new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
    el: '#app',
    store: __WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */],
    router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
    template: '<App/>',
    components: { App: __WEBPACK_IMPORTED_MODULE_1__App___default.a }
});

/***/ }),
/* 256 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return plate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return wanted; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return dmr; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return registry; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return inspection; });
/* unused harmony export latest */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return countVehicle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return postLookup; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__HttpService__ = __webpack_require__(14);


var namespace = 'https://api.nrpladetjek.dk/api/lookups';

var plate = function plate(options, cb, errorCb) {
    __WEBPACK_IMPORTED_MODULE_0__HttpService__["a" /* get */](namespace + '/plate', options, cb, errorCb);
};

var wanted = function wanted(options, cb, errorCb) {
    __WEBPACK_IMPORTED_MODULE_0__HttpService__["a" /* get */](namespace + '/wanted', options, cb, errorCb);
};

var dmr = function dmr(options, cb, errorCb) {
    __WEBPACK_IMPORTED_MODULE_0__HttpService__["a" /* get */](namespace + '/dmr', options, cb, errorCb);
};

var registry = function registry(options, cb, errorCb) {
    __WEBPACK_IMPORTED_MODULE_0__HttpService__["a" /* get */](namespace + '/registry', options, cb, errorCb);
};

var inspection = function inspection(options, cb, errorCb) {
    __WEBPACK_IMPORTED_MODULE_0__HttpService__["a" /* get */](namespace + '/inspection', options, cb, errorCb);
};

var latest = function latest(options, cb, errorCb) {
    __WEBPACK_IMPORTED_MODULE_0__HttpService__["a" /* get */](namespace + '/latest', options, cb, errorCb);
};

var countVehicle = function countVehicle(options, cb, errorCb) {
    __WEBPACK_IMPORTED_MODULE_0__HttpService__["a" /* get */](namespace + '/vehicle-count', options, cb, errorCb);
};

var postLookup = function postLookup(body, cb, errorCb) {
    __WEBPACK_IMPORTED_MODULE_0__HttpService__["b" /* post */](namespace, body, cb, errorCb);
};



/***/ }),
/* 257 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return find; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__HttpService__ = __webpack_require__(14);


var namespace = 'http://www.carimagery.com/api.asmx/GetImageUrl?searchTerm=';

var find = function find(makeAndModel, options, cb, errorCb) {
    __WEBPACK_IMPORTED_MODULE_0__HttpService__["a" /* get */](namespace + makeAndModel, options, cb, errorCb);
};



/***/ }),
/* 258 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app',
  components: {
    'layout': __webpack_require__(330)
  }
});

/***/ }),
/* 259 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    props: ['title']
});

/***/ }),
/* 260 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    props: ['title', 'value', 'suffix', 'wide', 'alignCenter', 'type']
});

/***/ }),
/* 261 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    name: '',
    data: function data() {
        return {
            isOnline: true
        };
    },
    created: function created() {
        this.updateStatus();
    },

    components: {
        'offline': __webpack_require__(329)
    },
    methods: {
        updateStatus: function updateStatus() {
            if (typeof window.navigator.onLine === 'undefined') {
                this.isOnline = true;
            } else {
                this.isOnline = window.navigator.onLine;
            }
            window.addEventListener('online', this.updateStatus);
            window.addEventListener('offline', this.updateStatus);
        }
    }
});

/***/ }),
/* 262 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_lookup_lookupService__ = __webpack_require__(15);





/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            licenseplate: '',
            vehicles: []
        };
    },

    methods: {
        doSearch: function doSearch() {
            var _this = this;

            __WEBPACK_IMPORTED_MODULE_1__services_lookup_lookupService__["b" /* find */](this.licenseplate, {}, function (response) {
                var vehicleData = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, response.data[0]);
                _this.vehicles.push(vehicleData);
                _this.licenseplate = '';
            });
        },
        removeVehicle: function removeVehicle(index) {
            this.vehicles.splice(index, 1);
        }
    }
});

/***/ }),
/* 263 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_lookup_lookupService__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);






/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            licenseplate: '',
            vehicleData: null,
            loading: false,
            inspectionReport: null,
            showInspectionReportModal: false,
            calculator: {
                kmPerYear: 15500,
                expensePerHundredKm: 30,
                payoff: 0,
                insurance: 4500
            }
        };
    },
    created: function created() {
        this.checkForQuery();
    },

    methods: {
        doSearch: function doSearch() {
            var _this = this;

            this.vehicleData = null;
            this.loading = true;
            __WEBPACK_IMPORTED_MODULE_1__services_lookup_lookupService__["b" /* find */](this.licenseplate, {}, function (response) {
                _this.vehicleData = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, response.data[0]);
                _this.loading = false;
                var carString = _this.licenseplate.toUpperCase() + ' | ' + _this.vehicleData.general.MaerkeTypeNavn + ' ' + _this.vehicleData.general.ModelTypeNavn + ' ' + _this.vehicleData.general.VariantTypeNavn;
                if (true) {
                    if ('ga' in window) {
                        var tracker = window.ga.getAll()[0];
                        if (tracker) {
                            tracker.send('event', 'Søgeresultat', 'Nummerplade', carString);
                            if (_this.vehicleData.dmr.Forsikring.Selskab === 'SELVFORSIKRING') {
                                tracker.send('event', 'Civile politibiler', 'Nummerplade', carString);
                            }
                        }
                    }
                    var vehicleResult = _this.vehicleData.general.MaerkeTypeNavn + ' ' + _this.vehicleData.general.ModelTypeNavn + ' ' + _this.vehicleData.general.VariantTypeNavn;
                    __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post('https://hooks.slack.com/services/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', {
                        username: 'NrPladeTjek.dk',
                        icon_url: 'https://nrpladetjek.dk/static/apple-icon.png',
                        text: '*' + _this.vehicleData.general.RegNr + '*\n' + vehicleResult + '\n----------'
                    }, {
                        headers: {
                            'Content-Type': 'application/x-www-form-urlencoded'
                        }
                    });
                }
            }, function (err) {
                alert('Vi kunne ikke finde nummerpladen. Tjek venligst det indtastede og prøv igen.');
                console.log(err);
                _this.loading = false;
                if (true) {
                    if ('ga' in window) {
                        var tracker = window.ga.getAll()[0];
                        if (tracker) {
                            tracker.send('event', 'Søgninger uden resultat', 'Nummerplade', _this.licenseplate);
                        }
                    }
                }
            });
        },
        checkForQuery: function checkForQuery() {
            var query = this.$route.params.licenseplate;
            if (query) {
                this.licenseplate = query;
                this.doSearch();
            }
        },
        showInspectionReport: function showInspectionReport(report) {
            this.showInspectionReportModal = true;
            this.inspectionReport = report;
        },
        closeInspectionReport: function closeInspectionReport() {
            this.inspectionReport = null;
        }
    },
    computed: {
        monthlyExpense: function monthlyExpense() {
            var consumption = this.calculator.kmPerYear / this.vehicleData.general.MotorKmPerLiter * 11;
            var serviceAndRepairs = this.calculator.kmPerYear / 100 * this.calculator.expensePerHundredKm;
            var payoff = this.calculator.payoff * 12;
            var insurance = this.calculator.insurance;
            return Number((consumption + serviceAndRepairs + payoff + insurance) / 12).toFixed(0);
        }
    }
});

/***/ }),
/* 264 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_vehicle_vehicleService__ = __webpack_require__(16);




/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            licenseplate: '',
            vehicles: []
        };
    },
    created: function created() {
        this.getVehicles();
    },

    methods: {
        doSearch: function doSearch() {
            var result = this.licenseplate.split(' ').join('').toUpperCase();

            if (result !== '') {
                window.location.href = '/soeg/' + result + '/overblik';
            } else {
                alert('Indtast venligst en nummerplade for at søge.');
            }
        },
        getVehicles: function getVehicles() {
            var _this = this;

            __WEBPACK_IMPORTED_MODULE_0__services_vehicle_vehicleService__["a" /* findAll */]({}, function (response) {
                _this.vehicles = response.data;
            });
        },
        goToRandomLicenseplate: function goToRandomLicenseplate() {
            var min = Math.floor(this.vehicles.length - 100);
            var max = this.vehicles.length;
            var randomNumber = Math.floor(Math.random() * (max - min + 1) + min);
            var licenseplate = this.vehicles[randomNumber].lookups[this.vehicles[randomNumber].lookups.length - 1].licenseplate;
            window.location.href = '/soeg/' + licenseplate + '/overblik';
        }
    },
    mounted: function mounted() {
        var _this2 = this;

        this.$nextTick(function () {
            return _this2.$refs.tester.focus();
        });
    }
});

/***/ }),
/* 265 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_lookup_lookupService__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_vehicle_vehicleService__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(320);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__partners__ = __webpack_require__(336);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__partners___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__partners__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_axios__);









/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            lookups: null,
            vehicles: null,
            showStatsCount: 0,
            newTotalLookups: 0,
            newTotalVehicles: 0,
            newLookupsYesterday: 0,
            newLookupsToday: 0
        };
    },
    created: function created() {
        this.getNewData();
        this.checkIfAdmin();
    },

    components: {
        Partners: __WEBPACK_IMPORTED_MODULE_3__partners___default.a
    },
    methods: {
        checkIfAdmin: function checkIfAdmin() {
            var url = window.location.href;
            if (url.includes('admin=true')) {
                this.showStatsCount = 5;
                this.updateRealtime(false);
            }
        },
        getLookups: function getLookups() {
            var _this = this;

            __WEBPACK_IMPORTED_MODULE_0__services_lookup_lookupService__["a" /* findAll */]({}, function (response) {
                _this.lookups = response.data;
            });
        },
        getVehicles: function getVehicles() {
            var _this2 = this;

            __WEBPACK_IMPORTED_MODULE_1__services_vehicle_vehicleService__["a" /* findAll */]({}, function (response) {
                var arr = [];
                response.data.forEach(function (vehicle) {
                    if (vehicle.horsepower < 1500) {
                        arr.push(vehicle);
                    }
                });
                _this2.vehicles = arr;
            });
        },
        goToVehicle: function goToVehicle(licenseplate) {
            window.location.href = '/soeg/' + licenseplate + '/overblik';
        },
        reloadLookups: function reloadLookups() {
            this.getNewData();
        },
        showStats: function showStats() {
            this.showStatsCount = this.showStatsCount + 1;
            if (this.showStatsCount === 5) {
                this.updateRealtime(true);
            }
        },
        getNewData: function getNewData() {
            var _this3 = this;

            __WEBPACK_IMPORTED_MODULE_5_axios___default.a.get('https://api.nrpladetjek.dk/api/lookups/count').then(function (response) {
                return _this3.newTotalLookups = response.data.count;
            });
            __WEBPACK_IMPORTED_MODULE_5_axios___default.a.get('https://api.nrpladetjek.dk/api/vehicles/count').then(function (response) {
                return _this3.newTotalVehicles = response.data.count;
            });
            __WEBPACK_IMPORTED_MODULE_5_axios___default.a.get('https://api.nrpladetjek.dk/api/lookups/count/yesterday').then(function (response) {
                return _this3.newLookupsYesterday = response.data.count;
            });
            __WEBPACK_IMPORTED_MODULE_5_axios___default.a.get('https://api.nrpladetjek.dk/api/lookups/count/today').then(function (response) {
                return _this3.newLookupsToday = response.data.count;
            });
        },
        updateRealtime: function updateRealtime(showNotification) {
            var _this4 = this;

            if (showNotification) {
                alert('God Mode activated - Du kan nu se stats! Alle stats opdateres hvert 10. sekund i God Mode.');
            }
            setInterval(function () {
                _this4.getNewData();
            }, 10000);
        }
    },
    watch: {
        '$store.state.vehicleData.general.RegNr': 'reloadLookups'
    },
    computed: {
        vehiclesSortedByHorsepower: function vehiclesSortedByHorsepower() {
            function compare(a, b) {
                if (a.horsepower < b.horsepower) {
                    return 1;
                }
                if (a.horsepower > b.horsepower) {
                    return -1;
                }
                return 0;
            }
            if (this.vehicles !== null && this.vehicles.length > 0) {
                return this.vehicles.sort(compare);
            }
        },
        vehiclesSortedByLookups: function vehiclesSortedByLookups() {
            var arr = [];
            var excludeLicenseplates = ['AL52114', 'AA88470', 'AL52111', 'BV73090', 'BP59902', 'BK83307', 'YE58285', 'HS13956', 'TESLA'];
            if (this.vehicles !== null && this.vehicles.length > 0) {
                this.vehicles.forEach(function (vehicle) {
                    if (!excludeLicenseplates.includes(vehicle.lookups[0].licenseplate.toUpperCase())) {
                        vehicle.lookupCount = vehicle.lookups.length;
                        arr.push(vehicle);
                    }
                });
            }

            if (this.vehicles !== null && this.vehicles.length > 0) {
                return __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.orderBy(arr, 'lookupCount', 'desc');
            }
        },
        latestLookups: function latestLookups() {
            var indexes = [];
            var arr = [];
            this.lookups.rows.forEach(function (lookup, index) {
                var licenseplate = lookup.licenseplate.toUpperCase();
                if (licenseplate.match(/[A-Z{1}]+[A-Z{1}]+[0-9{1}]+[0-9{1}]+[0-9{1}]+[0-9{1}]+[0-9{1}]/g) && licenseplate.length === 7) {
                    var splittedString = licenseplate.split('');
                    splittedString.splice(2, 0, ' ');
                    splittedString.splice(5, 0, ' ');
                    splittedString = splittedString.join('');
                    lookup.licenseplate = splittedString.toUpperCase();
                }
                if (index === 0) {
                    indexes.push(lookup.vehicle.id);
                    arr.push(lookup);
                } else {
                    if (!indexes.includes(lookup.vehicle.id)) {
                        indexes.push(lookup.vehicle.id);
                        arr.push(lookup);
                    }
                }
            });
            return arr;
        },
        lookupsToday: function lookupsToday() {
            var excludeLicenseplates = ['AL52114', 'AA88470', 'AL52111', 'BV73090', 'BP59902', 'BK83307', 'YE58285', 'HS13956', 'TESLA'];
            var count = 0;
            var d = new Date();
            d.setHours(0, 0, 0, 0);
            var today = __WEBPACK_IMPORTED_MODULE_4_moment___default()(d).format('X');
            this.lookups.rows.forEach(function (lookup) {
                var createdDate = __WEBPACK_IMPORTED_MODULE_4_moment___default()(lookup.createdAt).add(2, 'hours').format('X');
                var licenseplate = lookup.licenseplate.split(' ').join('');
                if (!excludeLicenseplates.includes(licenseplate.toUpperCase()) && createdDate > today) {
                    count++;
                }
            });
            return count;
        },
        lookupsYesterday: function lookupsYesterday() {
            var excludeLicenseplates = ['AL52114', 'AA88470', 'AL52111', 'BV73090', 'BP59902', 'BK83307', 'YE58285', 'HS13956', 'TESLA'];
            var count = 0;
            var d = new Date();
            d.setHours(0, 0, 0, 0);
            var today = __WEBPACK_IMPORTED_MODULE_4_moment___default()(d).format('X');
            this.lookups.rows.forEach(function (lookup) {
                var createdDate = __WEBPACK_IMPORTED_MODULE_4_moment___default()(lookup.createdAt).add(2, 'hours').format('X');
                var licenseplate = lookup.licenseplate.split(' ').join('');
                if (!excludeLicenseplates.includes(licenseplate.toUpperCase()) && createdDate < today && createdDate > today - 86400) {
                    count++;
                }
            });
            return count;
        }
    }
});

/***/ }),
/* 266 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);




/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            partners: [{
                name: 'Samlino (billede)',
                type: 'Forsikring',
                link: 'https://online.adservicemedia.dk/cgi-bin/click.pl?pid=33267&cid=7110&productGroup=Samlino',
                image: '/static/partners/samlino-500x500.jpg',
                partner: 'AdService'
            }, {
                name: 'Bil Magasinet (billede)',
                type: 'Magasin',
                link: 'https://online.adservicemedia.dk/cgi-bin/click.pl?pid=33267&cid=10416&productGroup=banner&media_id=83530',
                image: '/static/partners/bilm.jpeg',
                partner: 'AdService'
            }, {
                name: 'One2Move (billede)',
                type: 'Biludlejning',
                link: 'https://online.adservicemedia.dk/cgi-bin/click.pl?pid=33267&cid=5719&productGroup=Biludlejning',
                image: '/static/partners/one2move-400x400.jpg',
                partner: 'AdService'
            }, {
                name: 'Fastspeed (billede)',
                type: 'Bredbånd',
                link: 'https://online.adservicemedia.dk/cgi-bin/click.pl?pid=33267&cid=9581&productGroup=Fastspeed&media_id=83530',
                image: '/static/partners/fastspeed_square.png',
                partner: 'AdService'
            }]
        };
    },

    methods: {
        goToPartner: function goToPartner(name, link) {
            if (true) {
                var formattedText = ':male-detective: Affiliate klik på *' + name + '*';
                __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('https://hooks.slack.com/services/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', {
                    username: 'NrPladeTjek.dk',
                    icon_url: 'https://nrpladetjek.dk/static/apple-icon.png',
                    text: formattedText
                }, {
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded'
                    }
                });
                if ('ga' in window) {
                    var tracker = window.ga.getAll()[0];
                    if (tracker) {
                        tracker.send('event', 'Affiliate', 'Klik', name);
                    }
                }
            }
            window.open(link, '_blank');
        },
        goToInsurancePartner: function goToInsurancePartner(name) {
            var numberplate = this.$store.state.licenseplate.split(' ').join('').toUpperCase();

            var link = 'https://online.adservicemedia.dk/cgi-bin/click.pl?pid=33267&cid=7110&productGroup=Samlino&media_id=83530';
            if (true) {
                if ('ga' in window) {
                    var tracker = window.ga.getAll()[0];
                    if (tracker) {
                        tracker.send('event', 'Affiliate', 'Samlino');
                    }
                }
                var formattedText = ':male-detective: Affiliate klik på *' + name + '* med nrplade: ' + numberplate;
                __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('https://hooks.slack.com/services/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', {
                    username: 'NrPladeTjek.dk',
                    icon_url: 'https://nrpladetjek.dk/static/apple-icon.png',
                    text: formattedText
                }, {
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded'
                    }
                });
                if ('ga' in window) {
                    var _tracker = window.ga.getAll()[0];
                    if (_tracker) {
                        _tracker.send('event', 'Affiliate', 'Klik', name);
                    }
                }
            }
            window.open(link, '_blank');
        }
    }
});

/***/ }),
/* 267 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            activeMenuItem: 'overview',
            menuItems: [{
                name: 'Overblik',
                slug: 'overview',
                icon: 'car',
                link: 'SearchOverview'
            }, {
                name: 'BilBogen',
                slug: 'registry',
                icon: 'book-open',
                link: 'SearchRegistry'
            }, {
                name: 'Synsrapporter',
                slug: 'reports',
                icon: 'clipboard-list-check',
                link: 'SearchReports'
            }, {
                name: 'Afgifter',
                slug: 'charges',
                icon: 'envelope-open-dollar',
                link: 'SearchCharges'
            }, {
                name: 'Teknisk info',
                slug: 'technical-info',
                icon: 'cog',
                link: 'SearchTechnicalInfo'
            }]
        };
    },

    methods: {
        doSearch: function doSearch() {
            var licenseplate = this.$store.state.licenseplate.split(' ').join('');
            if (licenseplate !== '') {
                window.location.href = '/soeg/' + licenseplate + '/overblik';
            } else {
                alert('Indtast venligst en nummerplade for at søge.');
            }
        }
    }
});

/***/ }),
/* 268 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_topmenu__ = __webpack_require__(337);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_topmenu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_topmenu__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_footer__ = __webpack_require__(335);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_footer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_footer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_vehicle_vehicleService__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__sentry_browser__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__services_api_lookup_lookupService__ = __webpack_require__(256);











/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            image: null
        };
    },

    components: {
        TopMenu: __WEBPACK_IMPORTED_MODULE_0__components_topmenu___default.a,
        Foo: __WEBPACK_IMPORTED_MODULE_1__components_footer___default.a
    },
    created: function created() {
        this.checkForQuery();
    },

    methods: {
        checkForQuery: function checkForQuery() {
            if (this.$route.params.licenseplate !== null) {
                this.getCarDetails(this.$route.params.licenseplate);
            }
        },
        getCarDetails: function getCarDetails(licenseplate, redirectToOverview) {
            var _this = this;

            this.$store.state.carData.general = null;
            this.$store.state.carData.dmr = null;
            this.$store.state.carData.registry = null;
            this.$store.state.carData.inspection = null;
            this.$store.state.carData.lookups = null;
            this.$store.state.searching = true;
            var params = {
                'licenseplate': licenseplate
            };
            __WEBPACK_IMPORTED_MODULE_5__services_api_lookup_lookupService__["a" /* plate */](params, function (response) {
                var inputtedLicenseplate = licenseplate.split(' ').join('').toUpperCase();
                if (response.data.RegNr !== inputtedLicenseplate) {
                    window.location.href = '/soeg/' + response.data.RegNr + '/overblik';
                    return;
                }
                _this.$store.state.carData.general = response.data;

                var carId = response.data.KoeretoejId;
                var carVin = response.data.StelNr;
                var carPlate = response.data.RegNr;

                if (carPlate.toUpperCase().match(/[A-Z{1}]+[A-Z{1}]+[0-9{1}]+[0-9{1}]+[0-9{1}]+[0-9{1}]+[0-9{1}]/g) && carPlate.length === 7) {
                    var splittedString = licenseplate.split('');
                    splittedString.splice(2, 0, ' ');
                    splittedString.splice(5, 0, ' ');
                    splittedString = splittedString.join('');
                    _this.$store.state.licenseplate = splittedString.toUpperCase();
                } else {
                    _this.$store.state.licenseplate = licenseplate.toUpperCase();
                }

                _this.getWantedDetails(carPlate);
                _this.getDmrDetails(carId);
                _this.getRegistryDetails(carVin, carPlate);
                _this.getInspectionDetails(carVin, carId);
                _this.getLookups(carId);
                _this.postLookup(carId, carPlate);

                _this.$store.state.searching = false;
                _this.$store.state.match = true;
                _this.$store.state.showingResult = true;
                if (true) {
                    var carString = _this.$store.state.carData.general.RegNr.toUpperCase() + ' | ' + _this.$store.state.carData.general.MaerkeTypeNavn + ' ' + _this.$store.state.carData.general.ModelTypeNavn + ' ' + _this.$store.state.carData.general.VariantTypeNavn;
                    if ('ga' in window) {
                        var tracker = window.ga.getAll()[0];
                        if (tracker) {
                            tracker.send('event', 'Søgeresultat', 'Nummerplade', carString);
                        }
                    }
                }
                var hrefString = window.location.pathname;
                var slashCount = hrefString.match(/\//g).length;
                if (slashCount === 2) {
                    _this.$router.push({ name: 'SearchOverview' });
                }
                if (redirectToOverview) {
                    _this.$router.push({ name: 'SearchOverview' });
                }
            }, function (err) {
                console.log(err);
                _this.$store.state.searching = false;
                _this.$store.state.match = false;
                _this.$store.state.showingResult = true;
                _this.$store.state.isLoading = false;
                if (licenseplate.toUpperCase().match(/[A-Z{1}]+[A-Z{1}]+[0-9{1}]+[0-9{1}]+[0-9{1}]+[0-9{1}]+[0-9{1}]/g) && licenseplate.length === 7) {
                    var splittedString = licenseplate.split('');
                    splittedString.splice(2, 0, ' ');
                    splittedString.splice(5, 0, ' ');
                    splittedString = splittedString.join('');
                    _this.$store.state.licenseplate = splittedString.toUpperCase();
                } else {
                    _this.$store.state.licenseplate = licenseplate.toUpperCase();
                }
                __WEBPACK_IMPORTED_MODULE_4__sentry_browser__["b" /* captureException */](new Error('API error 2'));
                __WEBPACK_IMPORTED_MODULE_4__sentry_browser__["c" /* withScope */](function (scope) {
                    scope.setExtra('state', _this.$store.state);
                    scope.setExtra('data', err);
                    __WEBPACK_IMPORTED_MODULE_4__sentry_browser__["b" /* captureException */](new Error('New API error'));
                    if ('ga' in window) {
                        var tracker = window.ga.getAll()[0];
                        if (tracker) {
                            tracker.send('event', 'Fejl', 'New API error', _this.$store.state.licenceplate);
                        }
                    }
                });
            });
        },
        getWantedDetails: function getWantedDetails(licenseplate) {
            var _this2 = this;

            this.$store.state.loadingWanted = true;
            var params = {
                'licenseplate': licenseplate
            };
            __WEBPACK_IMPORTED_MODULE_5__services_api_lookup_lookupService__["b" /* wanted */](params, function (response) {
                _this2.$store.state.carData.wanted = response.data;
                _this2.$store.state.loadingWanted = false;
            }, function (err) {
                console.log(err);
                _this2.$store.state.loadingWanted = false;
            });
        },
        getDmrDetails: function getDmrDetails(vehicleUuid) {
            var _this3 = this;

            this.$store.state.loadingDmr = true;
            var params = {
                'vehicle_uuid': vehicleUuid
            };
            __WEBPACK_IMPORTED_MODULE_5__services_api_lookup_lookupService__["c" /* dmr */](params, function (response) {
                _this3.$store.state.carData.dmr = response.data;
                _this3.$store.state.loadingDmr = false;
            }, function (err) {
                _this3.$store.state.match = false;
                console.log(err);
                _this3.$store.state.loadingDmr = false;
            });
        },
        getRegistryDetails: function getRegistryDetails(vinNumber, licenseplate) {
            var _this4 = this;

            this.$store.state.loadingRegistry = true;
            var params = {
                'vin_number': vinNumber,
                'licenseplate': licenseplate
            };
            __WEBPACK_IMPORTED_MODULE_5__services_api_lookup_lookupService__["d" /* registry */](params, function (response) {
                _this4.$store.state.carData.registry = response.data;
                _this4.$store.state.loadingRegistry = false;
            }, function (err) {
                console.log(err);
                _this4.$store.state.loadingRegistry = false;
                _this4.$store.state.match = false;
            });
        },
        getInspectionDetails: function getInspectionDetails(vinNumber, vehicleUuid) {
            var _this5 = this;

            this.$store.state.loadingInspection = true;
            var params = {
                'vin_number': vinNumber,
                'vehicle_uuid': vehicleUuid
            };
            __WEBPACK_IMPORTED_MODULE_5__services_api_lookup_lookupService__["e" /* inspection */](params, function (response) {
                _this5.$store.state.carData.inspection = response.data;
                _this5.$store.state.loadingInspection = false;
            }, function (err) {
                console.log(err);
                _this5.$store.state.loadingInspection = false;
                _this5.$store.state.match = false;
            });
        },
        getLookups: function getLookups(vehicleUuid) {
            var _this6 = this;

            this.$store.state.loadingLookups = true;
            var params = {
                'vehicle_uuid': vehicleUuid
            };
            __WEBPACK_IMPORTED_MODULE_5__services_api_lookup_lookupService__["f" /* countVehicle */](params, function (response) {
                _this6.$store.state.carData.lookups = response.data;
                _this6.$store.state.loadingLookups = false;
            }, function (err) {
                console.log(err);
                _this6.$store.state.loadingLookups = false;
            });
        },
        postLookup: function postLookup(vehicleUuid, licenseplate) {
            var body = {
                'vehicle_uuid': vehicleUuid,
                'licenseplate': licenseplate
            };
            __WEBPACK_IMPORTED_MODULE_5__services_api_lookup_lookupService__["g" /* postLookup */](body, {}, function (respone) {}, function (err) {
                console.log(err);
            });
        },
        doSearch: function doSearch(licenseplate, redirectToOverview) {
            var _this7 = this;

            this.$store.state.vehicleData = null;
            this.$store.state.isLoading = true;
            var inputtedLicenseplate = licenseplate.split(' ').join('').toUpperCase();
            __WEBPACK_IMPORTED_MODULE_2__services_vehicle_vehicleService__["b" /* find */](licenseplate, {}, function (response) {
                _this7.$store.state.vehicleData = response.data;

                if (response.data.general.RegNr !== inputtedLicenseplate) {
                    window.location.href = '/soeg/' + response.data.general.RegNr + '/overblik';
                    return;
                }

                var licenseplate = _this7.$store.state.vehicleData.general.RegNr;

                if (licenseplate.toUpperCase().match(/[A-Z{1}]+[A-Z{1}]+[0-9{1}]+[0-9{1}]+[0-9{1}]+[0-9{1}]+[0-9{1}]/g) && licenseplate.length === 7) {
                    var splittedString = licenseplate.split('');
                    splittedString.splice(2, 0, ' ');
                    splittedString.splice(5, 0, ' ');
                    splittedString = splittedString.join('');
                    _this7.$store.state.licenseplate = splittedString.toUpperCase();
                } else {
                    _this7.$store.state.licenseplate = licenseplate.toUpperCase();
                }

                _this7.$store.state.isLoading = false;

                if (true) {
                    var carString = _this7.$store.state.vehicleData.general.RegNr.toUpperCase() + ' | ' + _this7.$store.state.vehicleData.general.MaerkeTypeNavn + ' ' + _this7.$store.state.vehicleData.general.ModelTypeNavn + ' ' + _this7.$store.state.vehicleData.general.VariantTypeNavn;
                    if ('ga' in window) {
                        var tracker = window.ga.getAll()[0];
                        if (tracker) {
                            tracker.send('event', 'Søgeresultat', 'Nummerplade', carString);
                            if (_this7.$store.state.vehicleData.dmr.Forsikring.Selskab === 'SELVFORSIKRING') {
                                tracker.send('event', 'Civile politibiler', 'Nummerplade', carString);
                            }
                            if (_this7.$store.state.vehicleData.wanted !== null && _this7.$store.state.vehicleData.wanted.PoliceWantedStatus === 0) {
                                tracker.send('event', 'Efterlyst køretøj', 'Nummerplade', carString);
                            }
                        }
                    }
                }
                var hrefString = window.location.pathname;
                var slashCount = hrefString.match(/\//g).length;
                if (slashCount === 2) {
                    _this7.$router.push({ name: 'SearchOverview' });
                }
                if (redirectToOverview) {
                    _this7.$router.push({ name: 'SearchOverview' });
                }
                if (false) {
                    _this7.searchCarImage();
                }
            }, function (err) {
                _this7.$store.state.isLoading = false;
                if (licenseplate.toUpperCase().match(/[A-Z{1}]+[A-Z{1}]+[0-9{1}]+[0-9{1}]+[0-9{1}]+[0-9{1}]+[0-9{1}]/g) && licenseplate.length === 7) {
                    var splittedString = licenseplate.split('');
                    splittedString.splice(2, 0, ' ');
                    splittedString.splice(5, 0, ' ');
                    splittedString = splittedString.join('');
                    _this7.$store.state.licenseplate = splittedString.toUpperCase();
                } else {
                    _this7.$store.state.licenseplate = licenseplate.toUpperCase();
                }
                __WEBPACK_IMPORTED_MODULE_4__sentry_browser__["b" /* captureException */](new Error('API error 2'));
                __WEBPACK_IMPORTED_MODULE_4__sentry_browser__["c" /* withScope */](function (scope) {
                    scope.setExtra('state', _this7.$store.state);
                    scope.setExtra('data', err);
                    __WEBPACK_IMPORTED_MODULE_4__sentry_browser__["b" /* captureException */](new Error('New API error'));
                    if ('ga' in window) {
                        var tracker = window.ga.getAll()[0];
                        if (tracker) {
                            tracker.send('event', 'Fejl', 'New API error', _this7.$store.state.licenceplate);
                        }
                    }
                });
            });
        },
        goToInsurancePartner: function goToInsurancePartner(name) {
            var numberplate = this.$store.state.licenseplate.split(' ').join('').toUpperCase();

            var link = 'https://online.adservicemedia.dk/cgi-bin/click.pl?pid=33267&cid=7110&productGroup=Samlino&media_id=83530';
            if (true) {
                if ('ga' in window) {
                    var tracker = window.ga.getAll()[0];
                    if (tracker) {
                        tracker.send('event', 'Affiliate', 'Samlino');
                    }
                }
                var formattedText = ':male-detective: Affiliate klik på *' + name + '* med nrplade: ' + numberplate;
                __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post('https://hooks.slack.com/services/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', {
                    username: 'NrPladeTjek.dk',
                    icon_url: 'https://nrpladetjek.dk/static/apple-icon.png',
                    text: formattedText
                }, {
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded'
                    }
                });
                if ('ga' in window) {
                    var _tracker = window.ga.getAll()[0];
                    if (_tracker) {
                        _tracker.send('event', 'Affiliate', 'Klik', name);
                    }
                }
            }
            window.open(link, '_blank');
        },
        goToBroadbandPartner: function goToBroadbandPartner(name) {
            var numberplate = this.$store.state.licenseplate.split(' ').join('').toUpperCase();
            var link = 'https://online.adservicemedia.dk/cgi-bin/click.pl?pid=33267&cid=9581&productGroup=Fastspeed&media_id=83530';
            if (true) {
                if ('ga' in window) {
                    var tracker = window.ga.getAll()[0];
                    if (tracker) {
                        tracker.send('event', 'Affiliate', 'Fastspeed');
                    }
                }
                var formattedText = ':male-detective: Affiliate klik på *' + name + '* med nrplade: ' + numberplate;
                __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post('https://hooks.slack.com/services/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', {
                    username: 'NrPladeTjek.dk',
                    icon_url: 'https://nrpladetjek.dk/static/apple-icon.png',
                    text: formattedText
                }, {
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded'
                    }
                });
                if ('ga' in window) {
                    var _tracker2 = window.ga.getAll()[0];
                    if (_tracker2) {
                        _tracker2.send('event', 'Affiliate', 'Klik', name);
                    }
                }
            }
            window.open(link, '_blank');
        },
        goToCasinoPartner: function goToCasinoPartner(name) {
            var link = 'https://online.adservicemedia.dk/cgi-bin/click.pl?pid=33267&cid=7474&productGroup=leovegas';
            if (true) {
                if ('ga' in window) {
                    var tracker = window.ga.getAll()[0];
                    if (tracker) {
                        tracker.send('event', 'Affiliate', 'Leo Vegas');
                    }
                }
                var formattedText = ':male-detective: Affiliate klik på *' + name + '*';
                __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post('https://hooks.slack.com/services/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', {
                    username: 'NrPladeTjek.dk',
                    icon_url: 'https://nrpladetjek.dk/static/apple-icon.png',
                    text: formattedText
                }, {
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded'
                    }
                });
                if ('ga' in window) {
                    var _tracker3 = window.ga.getAll()[0];
                    if (_tracker3) {
                        _tracker3.send('event', 'Affiliate', 'Klik', name);
                    }
                }
            }
            window.open(link, '_blank');
        },
        goToBilmagasinet: function goToBilmagasinet(type) {
            var link = 'https://online.adservicemedia.dk/cgi-bin/click.pl?pid=33267&cid=9340&productGroup=bonnier';
            if (true) {
                var formattedText = ':male-detective: Affiliate klik på *' + 'Bil Magasinet (' + type + ')*';
                __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post('https://hooks.slack.com/services/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', {
                    username: 'NrPladeTjek.dk',
                    icon_url: 'https://nrpladetjek.dk/static/apple-icon.png',
                    text: formattedText
                }, {
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded'
                    }
                });
                if ('ga' in window) {
                    var tracker = window.ga.getAll()[0];
                    if (tracker) {
                        tracker.send('event', 'Affiliate', 'Klik', 'Bil Magasinet (banner)');
                    }
                }
            }
            window.open(link, '_blank');
        }
    }
});

/***/ }),
/* 269 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    computed: {
        sortedCharges: function sortedCharges() {
            if (this.$store.state.carData.dmr !== null && this.$store.state.match) {
                this.$store.state.carData.dmr.Afgift.OpkraevedeAfgifter.forEach(function (charge) {
                    if (charge.RegNr.includes(' ')) {} else {
                        var splittedString = charge.RegNr.split('');
                        splittedString.splice(4, 0, ' ');
                        splittedString.splice(2, 0, ' ');
                        splittedString = splittedString.join('');
                        charge.RegNr = splittedString.toUpperCase();
                    }
                });
                return this.$store.state.carData.dmr.Afgift.OpkraevedeAfgifter;
            }
        }
    }
});

/***/ }),
/* 270 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_lookup_lookupService__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_vehicle_vehicleService__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_image_imageService__ = __webpack_require__(257);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_axios__);








/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            randomNumber: null,
            latestLookups: null,
            vehicles: null,
            image: null,
            showEconomyFields: false,
            calculator: {
                kmPerYear: 20000,
                gasPrice: 11,
                maintenancePerKm: 0.5,
                insurance: 8000,
                monthlyLoan: 0
            }
        };
    },
    mounted: function mounted() {
        this.getLatestLookups();
        this.getAllVehicles();
        this.randomNumber = Math.floor(Math.random() * 2 + 1);
    },

    methods: {
        getLatestLookups: function getLatestLookups() {
            var _this = this;

            __WEBPACK_IMPORTED_MODULE_0__services_lookup_lookupService__["a" /* findAll */]({}, function (response) {
                _this.latestLookups = response.data.rows;
            }, function (err) {
                console.log(err);
            });
        },
        getAllVehicles: function getAllVehicles() {
            var _this2 = this;

            __WEBPACK_IMPORTED_MODULE_1__services_vehicle_vehicleService__["a" /* findAll */]({}, function (response) {
                _this2.vehicles = response.data;
            });
        },
        searchCarImage: function searchCarImage() {
            var _this3 = this;

            var brand = encodeURI(this.$store.state.carData.general.MaerkeTypeNavn);
            var model = encodeURI(this.$store.state.carData.general.ModelTypeNavn);

            var searchString = brand + '+' + model;
            __WEBPACK_IMPORTED_MODULE_2__services_image_imageService__["a" /* find */](searchString, {}, function (response) {
                var formattedString = response.data.substr(79);
                var formattedStringSecond = formattedString.substr(0, formattedString.length - 9);
                _this3.image = formattedStringSecond;
            });
        },
        goToInsurancePartner: function goToInsurancePartner(name) {
            var numberplate = this.$store.state.licenseplate.split(' ').join('').toUpperCase();

            var link = 'https://online.adservicemedia.dk/cgi-bin/click.pl?pid=33267&cid=7110&productGroup=Samlino&media_id=83530';
            if (true) {
                if ('ga' in window) {
                    var tracker = window.ga.getAll()[0];
                    if (tracker) {
                        tracker.send('event', 'Affiliate', 'Samlino');
                    }
                }
                var formattedText = ':male-detective: Affiliate klik på *' + name + '* med nrplade: ' + numberplate;
                __WEBPACK_IMPORTED_MODULE_4_axios___default.a.post('https://hooks.slack.com/services/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', {
                    username: 'NrPladeTjek.dk',
                    icon_url: 'https://nrpladetjek.dk/static/apple-icon.png',
                    text: formattedText
                }, {
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded'
                    }
                });
                if ('ga' in window) {
                    var _tracker = window.ga.getAll()[0];
                    if (_tracker) {
                        _tracker.send('event', 'Affiliate', 'Klik', name);
                    }
                }
            }
            window.open(link, '_blank');
        },
        goToBroadbandPartner: function goToBroadbandPartner(name) {
            var numberplate = this.$store.state.licenseplate.split(' ').join('').toUpperCase();
            var link = 'https://online.adservicemedia.dk/cgi-bin/click.pl?pid=33267&cid=9581&productGroup=Fastspeed&media_id=83530';
            if (true) {
                if ('ga' in window) {
                    var tracker = window.ga.getAll()[0];
                    if (tracker) {
                        tracker.send('event', 'Affiliate', 'Fastspeed');
                    }
                }
                var formattedText = ':male-detective: Affiliate klik på *' + name + '* med nrplade: ' + numberplate;
                __WEBPACK_IMPORTED_MODULE_4_axios___default.a.post('https://hooks.slack.com/services/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', {
                    username: 'NrPladeTjek.dk',
                    icon_url: 'https://nrpladetjek.dk/static/apple-icon.png',
                    text: formattedText
                }, {
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded'
                    }
                });
                if ('ga' in window) {
                    var _tracker2 = window.ga.getAll()[0];
                    if (_tracker2) {
                        _tracker2.send('event', 'Affiliate', 'Klik', name);
                    }
                }
            }
            window.open(link, '_blank');
        },
        goToCasinoPartner: function goToCasinoPartner(name) {
            var link = 'https://online.adservicemedia.dk/cgi-bin/click.pl?pid=33267&cid=7474&productGroup=leovegas';
            if (true) {
                if ('ga' in window) {
                    var tracker = window.ga.getAll()[0];
                    if (tracker) {
                        tracker.send('event', 'Affiliate', 'Leo Vegas');
                    }
                }
                var formattedText = ':male-detective: Affiliate klik på *' + name + '*';
                __WEBPACK_IMPORTED_MODULE_4_axios___default.a.post('https://hooks.slack.com/services/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', {
                    username: 'NrPladeTjek.dk',
                    icon_url: 'https://nrpladetjek.dk/static/apple-icon.png',
                    text: formattedText
                }, {
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded'
                    }
                });
                if ('ga' in window) {
                    var _tracker3 = window.ga.getAll()[0];
                    if (_tracker3) {
                        _tracker3.send('event', 'Affiliate', 'Klik', name);
                    }
                }
            }
            window.open(link, '_blank');
        },
        goToBilmagasinet: function goToBilmagasinet(from) {
            var link = 'https://online.adservicemedia.dk/cgi-bin/click.pl?pid=33267&cid=9340&productGroup=bonnier';
            if (true) {
                var formattedText = ':male-detective: Affiliate klik på *' + 'Bil Magasinet (' + from + ')' + '*';
                __WEBPACK_IMPORTED_MODULE_4_axios___default.a.post('https://hooks.slack.com/services/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', {
                    username: 'NrPladeTjek.dk',
                    icon_url: 'https://nrpladetjek.dk/static/apple-icon.png',
                    text: formattedText
                }, {
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded'
                    }
                });
                if ('ga' in window) {
                    var tracker = window.ga.getAll()[0];
                    if (tracker) {
                        tracker.send('event', 'Affiliate', 'Klik', 'Bil Magasinet (' + from + ')');
                    }
                }
            }
            window.open(link, '_blank');
        },
        goToLoanPartner: function goToLoanPartner(from) {
            var link = 'https://online.adservicemedia.dk/cgi-bin/click.pl?pid=33267&cid=9364&productGroup=autol%EF%BF%BDnet&media_id=83530';
            if (true) {
                var formattedText = ':male-detective: Affiliate klik på *' + 'Santander (' + from + ')' + '*';
                __WEBPACK_IMPORTED_MODULE_4_axios___default.a.post('https://hooks.slack.com/services/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', {
                    username: 'NrPladeTjek.dk',
                    icon_url: 'https://nrpladetjek.dk/static/apple-icon.png',
                    text: formattedText
                }, {
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded'
                    }
                });
                if ('ga' in window) {
                    var tracker = window.ga.getAll()[0];
                    if (tracker) {
                        tracker.send('event', 'Affiliate', 'Klik', 'Santander (' + from + ')');
                    }
                }
            }
            window.open(link, '_blank');
        }
    },
    computed: {
        sortedLatestLookups: function sortedLatestLookups() {
            this.latestLookups.forEach(function (lookup) {
                lookup.fromNow = __WEBPACK_IMPORTED_MODULE_3_moment___default()(lookup.createdAt).fromNow();
            });
            return this.latestLookups;
        },
        sortedVehicles: function sortedVehicles() {
            function compare(a, b) {
                if (a.horsepower < b.horsepower) {
                    return 1;
                }
                if (a.horsepower > b.horsepower) {
                    return -1;
                }
                return 0;
            }
            return this.vehicles.sort(compare);
        },
        monthlyExpense: function monthlyExpense() {
            var consumption = this.calculator.kmPerYear / this.$store.state.carData.general.MotorKmPerLiter * 11;
            var serviceAndRepairs = this.calculator.kmPerYear / 100 * this.expensePerHundredKm;
            var payoff = this.calculator.payoff * 12;
            var insurance = this.calculator.insurance;
            return Number((consumption + serviceAndRepairs + payoff + insurance) / 12).toFixed(0);
        },
        daysUntilNextInspection: function daysUntilNextInspection() {
            if (this.$store.state.carData !== null && this.$store.state.carData.dmr.NaesteSyn) {
                var nextInspectionDate = __WEBPACK_IMPORTED_MODULE_3_moment___default()(this.$store.state.carData.dmr.NaesteSyn, 'YYYY-MM-DD').format('X');
                var today = __WEBPACK_IMPORTED_MODULE_3_moment___default()(new Date()).format('X');
                var result = Math.round((nextInspectionDate - today) / 86400) + 1;
                if (result < 0) {
                    return false;
                } else {
                    return result;
                }
            } else {
                return false;
            }
        },
        daysUntilNextCharge: function daysUntilNextCharge() {
            if (this.$store.state.carData !== null && this.$store.state.carData.dmr.Afgift.OpkraevedeAfgifter.length > 0) {
                var lastChargeEndDate = __WEBPACK_IMPORTED_MODULE_3_moment___default()(this.$store.state.carData.dmr.Afgift.OpkraevedeAfgifter[0].DaekkerTil, 'DD-MM-YYYY').format('X');
                var today = __WEBPACK_IMPORTED_MODULE_3_moment___default()(new Date()).format('X');
                var result = Math.round((lastChargeEndDate - today) / 86400) + 2;
                if (result < 0) {
                    return false;
                } else {
                    return result;
                }
            } else {
                return false;
            }
        },
        yearlyExpense: function yearlyExpense() {
            return 1000;
        },
        savingsWithShellCard: function savingsWithShellCard() {
            if (this.totalFuel) {
                var liters = this.totalFuel / this.calculator.gasPrice * 12;
                var savings = liters * 0.15;
                return Math.round(savings);
            } else {
                return false;
            }
        },
        totalFuel: function totalFuel() {
            if (this.$store.state.carData.general.MotorKmPerLiter) {
                var litersPerYear = this.calculator.kmPerYear / this.$store.state.carData.general.MotorKmPerLiter;
                var expensePerMonth = litersPerYear * this.calculator.gasPrice / 12;
                return Math.round(expensePerMonth).toFixed(0);
            } else {
                return false;
            }
        },
        totalMaintenance: function totalMaintenance() {
            var expensePerMonth = this.calculator.kmPerYear / 12 * this.calculator.maintenancePerKm;
            return Math.round(expensePerMonth).toFixed(0);
        },
        totalInsurance: function totalInsurance() {
            var expensePerMonth = this.calculator.insurance / 12;
            return Math.round(expensePerMonth).toFixed(0);
        },
        totalCharges: function totalCharges() {
            if (this.$store.state.match && !this.$store.state.loadingDmr && this.$store.state.carData !== null && this.$store.state.carData.dmr.Afgift.AfgiftDetaljer.length > 0) {
                var sum = this.$store.state.carData.dmr.Afgift.AfgiftDetaljer[this.$store.state.carData.dmr.Afgift.AfgiftDetaljer.length - 1].Pris;
                var a = sum.replace('.', '', -1);
                var b = a.replace(',', '.', -1);
                var c = b.substring(0, b.length - 4);
                if (this.$store.state.carData.dmr.Afgift.AfgiftDetaljer.length > 0 && this.$store.state.carData.dmr.Afgift.AfgiftDetaljer[0].Hyppighed === 'Halvårlig') {
                    return Number(c / 6).toFixed(0);
                } else if (this.$store.state.carData.dmr.Afgift.AfgiftDetaljer.length > 0 && this.$store.state.carData.dmr.Afgift.AfgiftDetaljer[0].Hyppighed === 'Årlig') {
                    return Number(c / 12).toFixed(0);
                } else {
                    return false;
                }
            } else {
                return false;
            }
        },
        totalExpensePerMonth: function totalExpensePerMonth() {
            var total = 0;
            if (this.totalFuel) {
                total = total + Number(this.totalFuel);
            }
            if (this.totalMaintenance) {
                total = total + Number(this.totalMaintenance);
            }
            if (this.totalInsurance) {
                total = total + Number(this.totalInsurance);
            }
            if (this.totalCharges) {
                total = total + Number(this.totalCharges);
            }
            if (this.calculator.monthlyLoan > 0) {
                total = total + Number(this.calculator.monthlyLoan);
            }
            return total.toFixed(0);
        },
        insuranceDate: function insuranceDate() {
            var date = __WEBPACK_IMPORTED_MODULE_3_moment___default()(this.$store.state.carData.dmr.Forsikring.Oprettet, 'DD-MM-YYYY').format('YYYY-MM-DD');
            return date;
        }
    }
});

/***/ }),
/* 271 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);




/* harmony default export */ __webpack_exports__["default"] = ({
    computed: {
        debitors: function debitors() {
            if (this.$store.state.carData.registry.LaaneDokumenter.length > 0) {
                this.$store.state.carData.registry.LaaneDokumenter[0].Debitorer.forEach(function (debitor) {
                    var firstname = debitor.Navn.split(' ')[0];
                    var lastname = debitor.Navn.split(' ')[1].substring(0, 1);
                    var birthday = __WEBPACK_IMPORTED_MODULE_0_moment___default()(debitor.FoedselsDato.substring(0, 6), 'DDMMYYYY').format('X');
                    var today = __WEBPACK_IMPORTED_MODULE_0_moment___default()(new Date()).format('X');
                    var years = (today - birthday) / 86400 / 365;
                    debitor.formattedName = firstname + ' ' + lastname + '.';
                    if (Math.floor(years) < 0) {
                        debitor.age = 100 + Math.floor(years);
                    } else {
                        debitor.age = Math.floor(years);
                    }
                });
                return this.$store.state.carData.registry.LaaneDokumenter[0].Debitorer;
            }
        },
        registryDate: function registryDate() {
            if (this.$store.state.carData.registry.LaaneDokumenter.length > 0) {
                return __WEBPACK_IMPORTED_MODULE_0_moment___default()(this.$store.state.carData.registry.LaaneDokumenter[0].Dato, 'DD-MM-YYYY').format('YYYY-MM-DD');
            }
        }
    }
});

/***/ }),
/* 272 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);




/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            activeReport: null
        };
    },
    created: function created() {
        if (this.$store.state.match && this.$store.state.carData.inspection && this.$store.state.carData.inspection.Rapporter.length > 0) {
            this.activeReport = 0;
        }
    },

    computed: {
        sortedReports: function sortedReports() {
            if (this.$store.state.match && this.$store.state.carData.inspection && this.$store.state.carData.inspection.Rapporter.length > 0) {
                this.$store.state.carData.inspection.Rapporter.forEach(function (report) {
                    report.SynsdatoFormateret = __WEBPACK_IMPORTED_MODULE_0_moment___default()(report.Synsdato, 'DD-MM-YYYY').format('YYYY-MM-DD[T]hh:mm');
                });
                return this.$store.state.carData.inspection.Rapporter;
            } else {
                return false;
            }
        }
    }
});

/***/ }),
/* 273 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    computed: {
        equipmentList: function equipmentList() {
            return this.$store.state.carData.general.KoeretoejUdstyrSamling.join(', ');
        }
    }
});

/***/ }),
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */,
/* 301 */,
/* 302 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 303 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 304 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 305 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 306 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 307 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 308 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 309 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 310 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 311 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 312 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 313 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 314 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 315 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 316 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 317 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 318 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 319 */,
/* 320 */,
/* 321 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 53,
	"./af.js": 53,
	"./ar": 60,
	"./ar-dz": 54,
	"./ar-dz.js": 54,
	"./ar-kw": 55,
	"./ar-kw.js": 55,
	"./ar-ly": 56,
	"./ar-ly.js": 56,
	"./ar-ma": 57,
	"./ar-ma.js": 57,
	"./ar-sa": 58,
	"./ar-sa.js": 58,
	"./ar-tn": 59,
	"./ar-tn.js": 59,
	"./ar.js": 60,
	"./az": 61,
	"./az.js": 61,
	"./be": 62,
	"./be.js": 62,
	"./bg": 63,
	"./bg.js": 63,
	"./bm": 64,
	"./bm.js": 64,
	"./bn": 65,
	"./bn.js": 65,
	"./bo": 66,
	"./bo.js": 66,
	"./br": 67,
	"./br.js": 67,
	"./bs": 68,
	"./bs.js": 68,
	"./ca": 69,
	"./ca.js": 69,
	"./cs": 70,
	"./cs.js": 70,
	"./cv": 71,
	"./cv.js": 71,
	"./cy": 72,
	"./cy.js": 72,
	"./da": 19,
	"./da.js": 19,
	"./de": 75,
	"./de-at": 73,
	"./de-at.js": 73,
	"./de-ch": 74,
	"./de-ch.js": 74,
	"./de.js": 75,
	"./dv": 76,
	"./dv.js": 76,
	"./el": 77,
	"./el.js": 77,
	"./en-SG": 78,
	"./en-SG.js": 78,
	"./en-au": 79,
	"./en-au.js": 79,
	"./en-ca": 80,
	"./en-ca.js": 80,
	"./en-gb": 81,
	"./en-gb.js": 81,
	"./en-ie": 82,
	"./en-ie.js": 82,
	"./en-il": 83,
	"./en-il.js": 83,
	"./en-nz": 84,
	"./en-nz.js": 84,
	"./eo": 85,
	"./eo.js": 85,
	"./es": 88,
	"./es-do": 86,
	"./es-do.js": 86,
	"./es-us": 87,
	"./es-us.js": 87,
	"./es.js": 88,
	"./et": 89,
	"./et.js": 89,
	"./eu": 90,
	"./eu.js": 90,
	"./fa": 91,
	"./fa.js": 91,
	"./fi": 92,
	"./fi.js": 92,
	"./fo": 93,
	"./fo.js": 93,
	"./fr": 96,
	"./fr-ca": 94,
	"./fr-ca.js": 94,
	"./fr-ch": 95,
	"./fr-ch.js": 95,
	"./fr.js": 96,
	"./fy": 97,
	"./fy.js": 97,
	"./ga": 98,
	"./ga.js": 98,
	"./gd": 99,
	"./gd.js": 99,
	"./gl": 100,
	"./gl.js": 100,
	"./gom-latn": 101,
	"./gom-latn.js": 101,
	"./gu": 102,
	"./gu.js": 102,
	"./he": 103,
	"./he.js": 103,
	"./hi": 104,
	"./hi.js": 104,
	"./hr": 105,
	"./hr.js": 105,
	"./hu": 106,
	"./hu.js": 106,
	"./hy-am": 107,
	"./hy-am.js": 107,
	"./id": 108,
	"./id.js": 108,
	"./is": 109,
	"./is.js": 109,
	"./it": 111,
	"./it-ch": 110,
	"./it-ch.js": 110,
	"./it.js": 111,
	"./ja": 112,
	"./ja.js": 112,
	"./jv": 113,
	"./jv.js": 113,
	"./ka": 114,
	"./ka.js": 114,
	"./kk": 115,
	"./kk.js": 115,
	"./km": 116,
	"./km.js": 116,
	"./kn": 117,
	"./kn.js": 117,
	"./ko": 118,
	"./ko.js": 118,
	"./ku": 119,
	"./ku.js": 119,
	"./ky": 120,
	"./ky.js": 120,
	"./lb": 121,
	"./lb.js": 121,
	"./lo": 122,
	"./lo.js": 122,
	"./lt": 123,
	"./lt.js": 123,
	"./lv": 124,
	"./lv.js": 124,
	"./me": 125,
	"./me.js": 125,
	"./mi": 126,
	"./mi.js": 126,
	"./mk": 127,
	"./mk.js": 127,
	"./ml": 128,
	"./ml.js": 128,
	"./mn": 129,
	"./mn.js": 129,
	"./mr": 130,
	"./mr.js": 130,
	"./ms": 132,
	"./ms-my": 131,
	"./ms-my.js": 131,
	"./ms.js": 132,
	"./mt": 133,
	"./mt.js": 133,
	"./my": 134,
	"./my.js": 134,
	"./nb": 135,
	"./nb.js": 135,
	"./ne": 136,
	"./ne.js": 136,
	"./nl": 138,
	"./nl-be": 137,
	"./nl-be.js": 137,
	"./nl.js": 138,
	"./nn": 139,
	"./nn.js": 139,
	"./pa-in": 140,
	"./pa-in.js": 140,
	"./pl": 141,
	"./pl.js": 141,
	"./pt": 143,
	"./pt-br": 142,
	"./pt-br.js": 142,
	"./pt.js": 143,
	"./ro": 144,
	"./ro.js": 144,
	"./ru": 145,
	"./ru.js": 145,
	"./sd": 146,
	"./sd.js": 146,
	"./se": 147,
	"./se.js": 147,
	"./si": 148,
	"./si.js": 148,
	"./sk": 149,
	"./sk.js": 149,
	"./sl": 150,
	"./sl.js": 150,
	"./sq": 151,
	"./sq.js": 151,
	"./sr": 153,
	"./sr-cyrl": 152,
	"./sr-cyrl.js": 152,
	"./sr.js": 153,
	"./ss": 154,
	"./ss.js": 154,
	"./sv": 155,
	"./sv.js": 155,
	"./sw": 156,
	"./sw.js": 156,
	"./ta": 157,
	"./ta.js": 157,
	"./te": 158,
	"./te.js": 158,
	"./tet": 159,
	"./tet.js": 159,
	"./tg": 160,
	"./tg.js": 160,
	"./th": 161,
	"./th.js": 161,
	"./tl-ph": 162,
	"./tl-ph.js": 162,
	"./tlh": 163,
	"./tlh.js": 163,
	"./tr": 164,
	"./tr.js": 164,
	"./tzl": 165,
	"./tzl.js": 165,
	"./tzm": 167,
	"./tzm-latn": 166,
	"./tzm-latn.js": 166,
	"./tzm.js": 167,
	"./ug-cn": 168,
	"./ug-cn.js": 168,
	"./uk": 169,
	"./uk.js": 169,
	"./ur": 170,
	"./ur.js": 170,
	"./uz": 172,
	"./uz-latn": 171,
	"./uz-latn.js": 171,
	"./uz.js": 172,
	"./vi": 173,
	"./vi.js": 173,
	"./x-pseudo": 174,
	"./x-pseudo.js": 174,
	"./yo": 175,
	"./yo.js": 175,
	"./zh-cn": 176,
	"./zh-cn.js": 176,
	"./zh-hk": 177,
	"./zh-hk.js": 177,
	"./zh-tw": 178,
	"./zh-tw.js": 178
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 321;

/***/ }),
/* 322 */,
/* 323 */,
/* 324 */,
/* 325 */,
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(311)

var Component = __webpack_require__(3)(
  /* script */
  null,
  /* template */
  __webpack_require__(356),
  /* scopeId */
  "data-v-87b029dc",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 330 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(261),
  /* template */
  __webpack_require__(346),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 331 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(303)

var Component = __webpack_require__(3)(
  /* script */
  null,
  /* template */
  __webpack_require__(347),
  /* scopeId */
  "data-v-301a1469",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 332 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(315)

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(262),
  /* template */
  __webpack_require__(360),
  /* scopeId */
  "data-v-d3b215d4",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 333 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(312)

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(263),
  /* template */
  __webpack_require__(357),
  /* scopeId */
  "data-v-94c7567a",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 334 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(308)

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(264),
  /* template */
  __webpack_require__(353),
  /* scopeId */
  "data-v-6743ed70",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 335 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(316)

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(265),
  /* template */
  __webpack_require__(361),
  /* scopeId */
  "data-v-d4b551a8",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 336 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(304)

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(266),
  /* template */
  __webpack_require__(348),
  /* scopeId */
  "data-v-31f01bfc",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 337 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(302)

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(267),
  /* template */
  __webpack_require__(345),
  /* scopeId */
  "data-v-04d0111a",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 338 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(318)
__webpack_require__(317)

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(268),
  /* template */
  __webpack_require__(362),
  /* scopeId */
  "data-v-e288fb6c",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 339 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(305)

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(269),
  /* template */
  __webpack_require__(350),
  /* scopeId */
  "data-v-368c1528",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 340 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(307)

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(270),
  /* template */
  __webpack_require__(352),
  /* scopeId */
  "data-v-4b6a8fc8",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 341 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(271),
  /* template */
  __webpack_require__(349),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 342 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(314)

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(272),
  /* template */
  __webpack_require__(359),
  /* scopeId */
  "data-v-cdbf5a28",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 343 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(313)

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(273),
  /* template */
  __webpack_require__(358),
  /* scopeId */
  "data-v-c2fa15fe",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 344 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(3)(
  /* script */
  null,
  /* template */
  __webpack_require__(363),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 345 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "top-menu"
  }, [_c('div', {
    staticClass: "searchbar"
  }, [(!_vm.$store.state.searching) ? _c('form', {
    staticClass: "animated fadeIn",
    attrs: {
      "action": "."
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.doSearch()
      }
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.$store.state.licenseplate),
      expression: "$store.state.licenseplate"
    }],
    staticClass: "hero-search",
    attrs: {
      "type": "search",
      "placeholder": "AL 52 114",
      "maxlength": "9"
    },
    domProps: {
      "value": (_vm.$store.state.licenseplate)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.$store.state, "licenseplate", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), (_vm.$store.state.match) ? _c('div', {
    staticClass: "vehicle-header animated zoomIn"
  }, [_c('div', {
    staticClass: "make-model"
  }, [_vm._v("\n                    " + _vm._s(_vm.$store.state.carData.general.MaerkeTypeNavn) + "\n                    "), (_vm.$store.state.carData.general.ModelTypeNavn !== 'UOPLYST' && _vm.$store.state.carData.general.ModelTypeNavn !== '-') ? _c('span', [_vm._v("\n                        " + _vm._s(_vm.$store.state.carData.general.ModelTypeNavn) + "\n                    ")]) : _vm._e()]), _vm._v(" "), (_vm.$store.state.carData.general.VariantTypeNavn !== 'UOPLYST' && _vm.$store.state.carData.general.VariantTypeNavn !== '-') ? _c('div', {
    staticClass: "variant"
  }, [_c('span', [_vm._v("\n                        " + _vm._s(_vm.$store.state.carData.general.VariantTypeNavn) + "\n                    ")]), _vm._v(" "), (_vm.$store.state.carData.general.KarrosseriTypeNavn && _vm.$store.state.carData.general.KarrosseriTypeNavn !== 'Hatchback') ? _c('span', [_vm._v("\n                        (" + _vm._s(_vm.$store.state.carData.general.KarrosseriTypeNavn) + ")\n                    ")]) : _vm._e()]) : _vm._e()]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.$store.state.searching) ? _c('div', {
    staticClass: "spinner-loader"
  }, [_vm._m(0)]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "container menu-container"
  }, [_c('div', {
    staticClass: "menu-wrapper"
  }, _vm._l((_vm.menuItems), function(item) {
    return _c('router-link', {
      key: item.slug,
      staticClass: "menu-item",
      class: {
        'active': item.slug === _vm.activeMenuItem
      },
      attrs: {
        "tag": "div",
        "to": {
          name: item.link
        }
      },
      on: {
        "click": function($event) {
          _vm.activeMenuItem = item.slug
        }
      }
    }, [_c('i', {
      class: 'fal fa-' + item.icon + ' fa-fw'
    }), _vm._v("\n                " + _vm._s(item.name) + "\n            ")])
  }), 1)]), _vm._v(" "), _c('div', {
    staticClass: "mobile-menu"
  }, _vm._l((_vm.menuItems), function(item) {
    return _c('router-link', {
      key: item.slug,
      staticClass: "menu-item",
      class: {
        'active': item.slug === _vm.activeMenuItem
      },
      attrs: {
        "tag": "div",
        "to": {
          name: item.link
        }
      },
      on: {
        "click": function($event) {
          _vm.activeMenuItem = item.slug
        }
      },
      nativeOn: {
        "click": function($event) {
          return _vm.$scrollToTop($event)
        }
      }
    }, [_c('div', {
      staticClass: "inner"
    }, [_c('i', {
      class: 'fal fa-' + item.icon + ' fa-fw'
    }), _vm._v(" "), _c('br'), _vm._v("\n                " + _vm._s(item.name) + "\n            ")])])
  }), 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "loader-wrapper"
  }, [_c('div', {
    staticClass: "lds-ring"
  }, [_c('div'), _vm._v(" "), _c('div'), _vm._v(" "), _c('div'), _vm._v(" "), _c('div')])])
}]}

/***/ }),
/* 346 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.isOnline) ? _c('div', {
    staticClass: "content"
  }, [_c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('router-view')], 1)], 1) : _c('offline')
},staticRenderFns: []}

/***/ }),
/* 347 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "error-page-wrapper"
  }, [_c('div', {
    staticClass: "error-page-inner"
  }, [_c('h1', [_vm._v("404")]), _vm._v(" "), _c('h3', [_vm._v("Whoops! Something went wrong...")]), _vm._v(" "), _c('p', [_vm._v("We could not find what you were looking for.")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "tag": "a",
      "to": {
        name: _vm.$route.name
      }
    }
  }, [_c('button', {
    staticClass: "btn btn-xs btn-primary"
  }, [_vm._v("\n                Refresh this page\n            ")])]), _vm._v("\n        |\n        "), _c('router-link', {
    attrs: {
      "tag": "a",
      "to": {
        name: 'Index'
      }
    }
  }, [_c('button', {
    staticClass: "btn btn-xs btn-primary"
  }, [_vm._v("\n                Go to \"home\"\n            ")])])], 1)])
},staticRenderFns: []}

/***/ }),
/* 348 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "partners"
  }, [_c('div', {
    staticClass: "container"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "content-layout"
  }, [_vm._l((_vm.partners), function(partner) {
    return (partner.name === 'Samlino (billede)') ? _c('div', {
      key: partner.name,
      staticClass: "column column__xs single-partner",
      on: {
        "click": function($event) {
          return _vm.goToInsurancePartner(partner.name)
        }
      }
    }, [_c('img', {
      attrs: {
        "src": partner.image
      }
    })]) : _vm._e()
  }), _vm._v(" "), _vm._l((_vm.partners), function(partner) {
    return (partner.name !== 'Samlino (billede)') ? _c('div', {
      key: partner.name,
      staticClass: "column column__xs single-partner",
      on: {
        "click": function($event) {
          return _vm.goToPartner(partner.name, partner.link)
        }
      }
    }, [_c('img', {
      attrs: {
        "src": partner.image
      }
    })]) : _vm._e()
  })], 2)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "large-title"
  }, [_vm._v("\n            Partneraftaler\n            "), _c('p', [_vm._v("\n                Vores samarbejdspartnere tilbyder lige nu følgende kampagner:\n            ")])])
}]}

/***/ }),
/* 349 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "registry"
  }, [_c('div', {
    staticClass: "content-layout"
  }, [_c('div', {
    staticClass: "column column__large"
  }, [(!_vm.$store.state.loadingRegistry && _vm.$store.state.carData.registry.LaaneDokumenter.length > 0) ? _c('div', {
    staticClass: "block"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "body narrow align-top"
  }, [_vm._v("\n                    Vær opmærksom på, at der er registreret pant i dette køretøj. Det betyder, at den nuværende ejer skylder penge væk i køretøjet. Vær sikker på, at sælger får indfriet gælden inden salg.\n                    "), _c('hr'), _vm._v(" "), _vm._l((_vm.debitors), function(debitor) {
    return _c('line-data', {
      key: debitor.formattedName,
      attrs: {
        "title": "Debitor",
        "value": debitor.formattedName
      }
    }, [_c('span', {
      staticClass: "extra",
      attrs: {
        "slot": "extra"
      },
      slot: "extra"
    }, [_vm._v("\n                            (" + _vm._s(debitor.age) + " år)\n                        ")])])
  }), _vm._v(" "), (_vm.$store.state.carData.registry.LaaneDokumenter[0].Underpanthaver) ? _c('line-data', {
    attrs: {
      "title": "Underpanthaver",
      "value": _vm.$store.state.carData.registry.LaaneDokumenter[0].Underpanthaver
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.$store.state.carData.registry.LaaneDokumenter[0].Underpanthaver && _vm.$store.state.carData.registry.LaaneDokumenter[0].Kreditorer[0]) ? _c('line-data', {
    attrs: {
      "title": "Kreditor",
      "value": _vm.$store.state.carData.registry.LaaneDokumenter[0].Kreditorer[0].Navn
    }
  }) : _vm._e(), _vm._v(" "), _c('line-data', {
    attrs: {
      "title": "Stelnummer",
      "value": _vm.$store.state.carData.general.StelNr
    }
  }), _vm._v(" "), _c('line-data', {
    attrs: {
      "title": "Type",
      "value": _vm.$store.state.carData.registry.LaaneDokumenter[0].DokumentType
    }
  }), _vm._v(" "), _c('line-data', {
    attrs: {
      "title": "Dato",
      "value": _vm._f("moment")(_vm.registryDate, 'D. MMMM YYYY')
    }
  }), _vm._v(" "), _c('line-data', {
    attrs: {
      "title": "Hovedstol",
      "value": _vm._f("currency")(_vm.$store.state.carData.registry.LaaneDokumenter[0].HovedStol),
      "suffix": "kr."
    }
  }), _vm._v(" "), _c('line-data', {
    attrs: {
      "title": "Rente",
      "value": _vm.$store.state.carData.registry.LaaneDokumenter[0].InterestRate,
      "suffix": "%"
    }
  }), _vm._v(" "), _c('line-data', {
    attrs: {
      "title": "Særlige vilkår",
      "value": _vm.$store.state.carData.registry.LaaneDokumenter[0].SaerligeLaanevilkaar
    }
  }), _vm._v(" "), _c('line-data', {
    attrs: {
      "title": "Løbenummer",
      "value": _vm.$store.state.carData.registry.LaaneDokumenter[0].LoebeNummer
    }
  }), _vm._v(" "), _vm._l((_vm.$store.state.carData.registry.LaaneDokumenter[0].TillaegsTekster), function(warning, index) {
    return (index === 0) ? _c('line-data', {
      key: warning,
      attrs: {
        "title": "Bemærkninger",
        "value": warning
      }
    }) : _vm._e()
  }), _vm._v(" "), _vm._l((_vm.$store.state.carData.registry.LaaneDokumenter[0].TillaegsTekster), function(warning, index) {
    return (index !== 0) ? _c('line-data', {
      key: warning,
      attrs: {
        "title": "",
        "value": warning
      }
    }) : _vm._e()
  }), _vm._v(" "), _c('hr'), _vm._v(" "), _vm._m(1)], 2)]) : _c('div', {
    staticClass: "block"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "body"
  }, [_vm._v("\n                    Ifølge de offentlige oplysninger, som vi indhenter, er der ingen restgæld (pant) i dette køretøj.\n                    "), _c('br'), _c('br'), _vm._v("\n                    Vi opdaterer vores oplysninger en gang i døgnet\n                    "), _c('br'), _c('br'), _vm._v("\n                    Tjek venligst "), _c('a', {
    attrs: {
      "href": "https://www.tinglysning.dk/t/#/top/forespoerg/bilbogen",
      "target": "_blank",
      "rel": "noopener"
    }
  }, [_vm._v("www.tingstyrelsen.dk")]), _vm._v(" for de nyeste oplysninger.\n                    "), _c('br'), _vm._v("\n                    Du skal bruge køretøjets stelnummer, som er "), _c('b', [_vm._v(_vm._s(_vm.$store.state.carData.general.StelNr))]), _vm._v(".\n                ")])])]), _vm._v(" "), _vm._m(3)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title"
  }, [_c('i', {
    staticClass: "fal fa-exclamation fa-fw"
  }), _vm._v("\n                    Der er registreret restgæld i dette køretøj\n                ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "meta",
    staticStyle: {
      "opacity": ".5"
    }
  }, [_c('div', [_vm._v("\n                            Oplysningerne opdateres en gang i døgnet.\n                        ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title"
  }, [_c('i', {
    staticClass: "fal fa-check fa-fw"
  }), _vm._v("\n                    Ingen restgæld registreret i dette køretøj\n                ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "column column__small"
  }, [_c('div', {
    staticClass: "block"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n                    BilBogen\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "body"
  }, [_vm._v("\n                    BilBogen er et offentligt register, hvor kreditorer kan registrere pant og udlæg over motorkøretøjer (bil, motorcykel m.fl.).\n                    "), _c('br'), _c('br'), _vm._v("\n                    Alle oplysninger i BilBogen er offentlige og kan findes på "), _c('a', {
    attrs: {
      "href": "https://tinglysning.dk",
      "target": "_blank",
      "rel": "noopener"
    }
  }, [_vm._v("www.tinglysning.dk")]), _vm._v(".\n                ")])]), _vm._v(" "), _c('div', {
    staticClass: "block"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n                    Restgæld / pant\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "body"
  }, [_vm._v("\n                    Kreditorer, som låner penge til køb af motorkøretøjer, kan få stillet sikkerhed i motorkøretøjet (pant) for at sikre, at debitor betaler gælden. Hvis gælden misligholdes, kan kreditor sælge bilen for at inddrive det skyldige beløb.\n                    "), _c('br'), _c('br'), _vm._v("\n                    Der er intet farligt i at købe en brugt bil med restgæld / pant. Du skal blot sikre dig, at sælger indfrier denne gæld ved købet.\n                ")])])])
}]}

/***/ }),
/* 350 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "charges"
  }, [(!_vm.$store.state.loadingDmr) ? _c('div', {
    staticClass: "content-layout"
  }, [_c('div', {
    staticClass: "column column__small"
  }, [_c('div', {
    staticClass: "block"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n                    Afgiftsdetaljer\n                ")]), _vm._v(" "), (_vm.$store.state.carData.dmr.Afgift.AfgiftDetaljer.length > 0) ? _c('div', {
    staticClass: "body"
  }, [_vm._l((_vm.$store.state.carData.dmr.Afgift.AfgiftDetaljer), function(charge) {
    return _c('line-data', {
      key: charge.DaekkerFra,
      attrs: {
        "title": charge.AfgiftType,
        "value": charge.Pris,
        "wide": true
      }
    })
  }), _vm._v(" "), _c('hr'), _vm._v(" "), _c('line-data', {
    attrs: {
      "title": "Hyppighed",
      "value": _vm.$store.state.carData.dmr.Afgift.AfgiftDetaljer[0].Hyppighed
    }
  })], 2) : _c('div', {
    staticClass: "body"
  }, [_vm._v("\n                    Ingen afgiftsdetaljer\n                ")])])]), _vm._v(" "), _c('div', {
    staticClass: "column column__large"
  }, [_c('div', {
    staticClass: "block charges-block"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n                    Opkrævede afgifter\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "body table"
  }, [(_vm.$store.state.carData.dmr.Afgift.OpkraevedeAfgifter.length > 0) ? _c('table', [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.sortedCharges), function(charge, index) {
    return _c('tr', {
      key: index
    }, [_c('td', [_c('div', {
      staticClass: "lp"
    }, [_vm._v(_vm._s(charge.RegNr))])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(charge.AfgiftType))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(charge.DaekkerFra) + " - " + _vm._s(charge.DaekkerTil))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(charge.Pris))])])
  }), 0)]) : _c('div', [_vm._v("\n                        Der er endnu ikke opkrævet afgifter på dette køretøj.\n                    ")])])]), _vm._v(" "), _c('div', {
    staticClass: "block charges-block-mobile"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n                    Opkrævede afgifter\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "body table"
  }, [(_vm.$store.state.carData.dmr.Afgift.OpkraevedeAfgifter.length > 0) ? _c('div', _vm._l((_vm.sortedCharges), function(charge, index) {
    return _c('div', {
      key: index,
      staticClass: "single-charge"
    }, [_c('line-data', {
      attrs: {
        "title": "Reg.Nr.",
        "value": charge.RegNr
      }
    }), _vm._v(" "), _c('line-data', {
      attrs: {
        "title": "Type",
        "value": charge.AfgiftType
      }
    }), _vm._v(" "), _c('line-data', {
      attrs: {
        "title": "Periode",
        "value": charge.DaekkerFra + ' - ' + charge.DaekkerTil
      }
    }), _vm._v(" "), _c('line-data', {
      attrs: {
        "title": "Pris",
        "value": charge.Pris
      }
    }), _vm._v(" "), (index !== _vm.sortedCharges.length - 1) ? _c('hr') : _vm._e()], 1)
  }), 0) : _c('div', [_vm._v("\n                        Der er endnu ikke opkrævet afgifter på dette køretøj.\n                    ")])])])])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    attrs: {
      "width": "20%"
    }
  }, [_vm._v("Reg.nr.")]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "35%"
    }
  }, [_vm._v("Type")]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "30%"
    }
  }, [_vm._v("Dækker fra - til")]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "15%"
    }
  }, [_vm._v("Pris")])])])
}]}

/***/ }),
/* 351 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('layout')], 1)
},staticRenderFns: []}

/***/ }),
/* 352 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "overview"
  }, [_c('div', {
    staticClass: "content-layout"
  }, [_c('div', {
    staticClass: "column column__large"
  }, [_c('div', {
    staticClass: "block fullheight animated fadeIn"
  }, [_c('div', {
    staticClass: "title"
  }, [(_vm.$store.state.carData.general.KoeretoejArtNavn === 'Motorcykel') ? _c('i', {
    staticClass: "fal fa-motorcycle fa-fw"
  }) : _c('i', {
    staticClass: "fal fa-car fa-fw"
  }), _vm._v("\n                    Køretøjet\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "body"
  }, [_c('line-data', {
    attrs: {
      "title": "Type",
      "value": _vm.$store.state.carData.general.KoeretoejArtNavn
    }
  }), _vm._v(" "), _c('line-data', {
    attrs: {
      "title": "Stelnummer",
      "value": _vm.$store.state.carData.general.StelNr
    }
  }), _vm._v(" "), _c('line-data', {
    attrs: {
      "title": "Status",
      "value": _vm.$store.state.carData.general.Status
    }
  }, [_c('span', {
    attrs: {
      "slot": "extra"
    },
    slot: "extra"
  }, [_vm._v("\n                            d. " + _vm._s(_vm._f("moment")(_vm.$store.state.carData.general.StatusDato, 'D. MMMM YYYY')) + "\n                        ")])]), _vm._v(" "), _c('line-data', {
    attrs: {
      "title": "Indregistreret",
      "value": _vm._f("moment")(_vm.$store.state.carData.general.FoersteRegistreringDato, 'D. MMMM YYYY')
    }
  }), _vm._v(" "), _c('hr'), _vm._v(" "), (!_vm.$store.state.searching && _vm.$store.state.carData.lookups !== null) ? _c('div', [_vm._v("\n                        Dette køretøj er blevet fremsøgt\n                        "), (!_vm.$store.state.loadingLookups && _vm.$store.state.carData.lookups !== null && _vm.$store.state.carData.lookups.count > 0) ? _c('b', [_vm._v("\n                            " + _vm._s(_vm.$store.state.carData.lookups.count) + " gange\n                        ")]) : _c('b', [_vm._v("\n                            1 gang\n                        ")]), _vm._v(" "), (_vm.$store.state.carData.lookups && _vm.$store.state.carData.lookups.count > 0) ? _c('span', [_vm._v("\n                            og senest d.\n                            "), _c('b', [_vm._v("\n                                " + _vm._s(_vm._f("moment")(_vm.$store.state.carData.lookups.latest, 'D. MMMM YYYY [kl.] HH:mm')) + "\n                            ")])]) : _vm._e()]) : _vm._e()], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "column column__small"
  }, [_c('div', {
    staticClass: "block fullheight animated fadeIn"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "body"
  }, [(_vm.$store.state.match && !_vm.$store.state.loadingDmr && !_vm.$store.state.loadingInspection && !_vm.$store.state.loadingRegistry) ? _c('div', {
    staticClass: "checks"
  }, [(_vm.$store.state.carData.registry.LaaneDokumenter.length > 0 && !_vm.$store.state.carData.dmr.BilenErLeaset) ? _c('div', {
    staticClass: "single-check neutral"
  }, [_c('i', {
    staticClass: "fas fa-info fa-fw"
  }), _vm._v(" "), _c('span', [_vm._v("\n                                Der er restgæld i køretøjet\n                            ")])]) : _vm._e(), _vm._v(" "), (_vm.$store.state.carData.registry.LaaneDokumenter.length === 0 && !_vm.$store.state.carData.dmr.BilenErLeaset) ? _c('div', {
    staticClass: "single-check good"
  }, [_c('i', {
    staticClass: "fas fa-check fa-fw"
  }), _vm._v(" "), _c('span', [_vm._v("\n                                Ingen restgæld i køretøjet\n                            ")])]) : _vm._e(), _vm._v(" "), (_vm.$store.state.carData.dmr.BilenErLeaset) ? _c('div', {
    staticClass: "single-check neutral"
  }, [_c('i', {
    staticClass: "fas fa-info fa-fw"
  }), _vm._v(" "), _c('span', [_vm._v("\n                                Køretøjet er leaset\n                                "), _c('br'), _vm._v("\n                                (" + _vm._s(_vm._f("moment")(_vm.$store.state.carData.general.LeasingGyldigFra, 'DD/MM/YYYY')) + "\n                                -\n                                " + _vm._s(_vm._f("moment")(_vm.$store.state.carData.general.LeasingGyldigTil, 'DD/MM/YYYY')) + ")\n                            ")])]) : _vm._e(), _vm._v(" "), (_vm.$store.state.carData.wanted !== null && _vm.$store.state.carData.wanted.PoliceWantedStatus === 1 || !_vm.$store.state.carData.wanted) ? _c('div', {
    staticClass: "single-check good"
  }, [_c('i', {
    staticClass: "fas fa-check fa-fw"
  }), _vm._v(" "), _c('span', [_vm._v("\n                                Køretøjet er ikke efterlyst\n                            ")])]) : _vm._e(), _vm._v(" "), (_vm.$store.state.carData.wanted !== null && _vm.$store.state.carData.wanted.PoliceWantedStatus === 0) ? _c('div', {
    staticClass: "single-check bad"
  }, [_c('i', {
    staticClass: "fas fa-exclamation fa-fw"
  }), _vm._v(" "), _c('span', [_vm._v("\n                                Køretøjet er efterlyst\n                            ")])]) : _vm._e(), _vm._v(" "), (_vm.$store.state.carData.inspection !== null && _vm.$store.state.carData.inspection.MistaenkeligtKmStand && _vm.$store.state.carData.inspection) ? _c('div', {
    staticClass: "single-check neutral"
  }, [_c('i', {
    staticClass: "fas fa-info fa-fw"
  }), _vm._v(" "), _c('span', [_vm._v("\n                                Mistænkelig km-stand\n                            ")])]) : _vm._e(), _vm._v(" "), (_vm.$store.state.carData.inspection !== null && !_vm.$store.state.carData.inspection.MistaenkeligtKmStand && _vm.$store.state.carData.inspection) ? _c('div', {
    staticClass: "single-check good"
  }, [_c('i', {
    staticClass: "fas fa-check fa-fw"
  }), _vm._v(" "), _c('span', [_vm._v("\n                                Ingen mistanke om km-fusk\n                            ")])]) : _vm._e(), _vm._v(" "), (_vm.$store.state.carData.inspection && _vm.$store.state.carData.inspection.Rapporter.length > 0 && _vm.$store.state.carData.inspection.Rapporter[0].Synsresultat === 'Godkendt') ? _c('div', {
    staticClass: "single-check good"
  }, [_c('i', {
    staticClass: "fas fa-check fa-fw"
  }), _vm._v(" "), _c('span', [_vm._v("\n                                Køretøjet bestod sidste syn\n                            ")])]) : _vm._e(), _vm._v(" "), (_vm.$store.state.carData.inspection && _vm.$store.state.carData.inspection.Rapporter.length > 0 && _vm.$store.state.carData.inspection.Rapporter[0].Synsresultat === 'Betinget godkendt') ? _c('div', {
    staticClass: "single-check neutral"
  }, [_c('i', {
    staticClass: "fas fa-info fa-fw"
  }), _vm._v(" "), _c('span', [_vm._v("\n                                \"Betinget godkendt\" ved sidste syn\n                            ")])]) : _vm._e(), _vm._v(" "), (_vm.$store.state.carData.inspection && _vm.$store.state.carData.inspection.Rapporter.length > 0 && _vm.$store.state.carData.inspection.Rapporter[0].Synsresultat === 'Middel') ? _c('div', {
    staticClass: "single-check neutral"
  }, [_c('i', {
    staticClass: "fas fa-info fa-fw"
  }), _vm._v(" "), _c('span', [_vm._v("\n                                \"Middel\" ved sidste syn\n                            ")])]) : _vm._e(), _vm._v(" "), (_vm.$store.state.carData.inspection && _vm.$store.state.carData.inspection.Rapporter.length > 0 && _vm.$store.state.carData.inspection.Rapporter[0].Synsresultat !== 'Godkendt' && _vm.$store.state.carData.inspection.Rapporter[0].Synsresultat !== 'Betinget godkendt' && _vm.$store.state.carData.inspection.Rapporter[0].Synsresultat !== 'Middel') ? _c('div', {
    staticClass: "single-check bad"
  }, [_c('i', {
    staticClass: "fas fa-exclamation fa-fw"
  }), _vm._v(" "), _c('span', [_vm._v("\n                                Bestod ikke sidste syn\n                            ")])]) : _vm._e(), _vm._v(" "), (_vm.$store.state.carData.inspection && _vm.$store.state.carData.inspection.Rapporter.length === 0) ? _c('div', {
    staticClass: "single-check good"
  }, [_c('i', {
    staticClass: "fas fa-check fa-fw"
  }), _vm._v(" "), _c('span', [_vm._v("\n                                Endnu ikke synet\n                            ")])]) : _vm._e(), _vm._v(" "), (!_vm.$store.state.carData.inspection) ? _c('div', {
    staticClass: "single-check neutral"
  }, [_c('i', {
    staticClass: "fas fa-info fa-fw"
  }), _vm._v(" "), _c('span', [_vm._v("\n                                Ingen synsdata\n                            ")])]) : _vm._e(), _vm._v(" "), (_vm.$store.state.carData.dmr.Forsikring.Status !== null && _vm.$store.state.carData.dmr.Forsikring.Status === 'Aktiv' && _vm.$store.state.carData.general.Status !== 'Afmeldt') ? _c('div', {
    staticClass: "single-check good"
  }, [_c('i', {
    staticClass: "fas fa-check fa-fw"
  }), _vm._v(" "), _c('span', [_vm._v("\n                                Køretøjet er forsikret\n                            ")])]) : _vm._e(), _vm._v(" "), (_vm.$store.state.carData.dmr.Forsikring.Status !== null && _vm.$store.state.carData.dmr.Forsikring.Status !== 'Aktiv' && _vm.$store.state.carData.general.Status !== 'Afmeldt') ? _c('div', {
    staticClass: "single-check bad"
  }, [_c('i', {
    staticClass: "fas fa-exclamation fa-fw"
  }), _vm._v(" "), _c('span', [_vm._v("\n                                Køretøjet er ikke forsikret\n                            ")])]) : _vm._e(), _vm._v(" "), (!_vm.$store.state.carData.dmr.Forsikring.Status) ? _c('div', {
    staticClass: "single-check neutral"
  }, [_c('i', {
    staticClass: "fas fa-info fa-fw"
  }), _vm._v(" "), _c('span', [_vm._v("\n                                Ingen forsikringsoplysninger\n                            ")])]) : _vm._e(), _vm._v(" "), (_vm.$store.state.carData.dmr.Forsikring.Selskab === 'SELVFORSIKRING') ? _c('div', {
    staticClass: "single-check bad"
  }, [_c('i', {
    staticClass: "fal fa-exclamation fa-fw"
  }), _vm._v(" "), _c('span', [_vm._v("\n                                Muligvis en civil politibil\n                            ")])]) : _vm._e(), _vm._v(" "), (_vm.$store.state.carData.general.Status && _vm.$store.state.carData.general.Status === 'Afmeldt') ? _c('div', {
    staticClass: "single-check neutral"
  }, [_c('i', {
    staticClass: "fal fa-info fa-fw"
  }), _vm._v(" "), _c('span', [_vm._v("\n                                Køretøjet er afmeldt\n                            ")])]) : _vm._e()]) : _c('data-loader', {
    attrs: {
      "title": "Henter data"
    }
  })], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "content-layout"
  }, [_c('div', {
    staticClass: "column column__third"
  }, [_c('div', {
    staticClass: "block fullheight animated fadeIn delay-1s"
  }, [_vm._m(1), _vm._v(" "), (!_vm.$store.state.loadingInspection && !_vm.$store.state.loadingDmr) ? _c('div', {
    staticClass: "body"
  }, [(_vm.$store.state.carData.dmr.SidsteSyn) ? _c('line-data', {
    attrs: {
      "title": "Sidste syn",
      "value": _vm._f("moment")(_vm.$store.state.carData.dmr.SidsteSyn, 'D. MMMM YYYY')
    }
  }) : _c('line-data', {
    attrs: {
      "title": "Sidste syn",
      "value": "Endnu ikke synet"
    }
  }), _vm._v(" "), _c('line-data', {
    attrs: {
      "title": "Næste syn om",
      "value": _vm.daysUntilNextInspection,
      "suffix": "dage"
    }
  }), _vm._v(" "), _c('router-link', {
    staticClass: "block-cta",
    attrs: {
      "tag": "div",
      "to": {
        name: 'SearchReports'
      }
    },
    nativeOn: {
      "click": function($event) {
        return _vm.$scrollToTop($event)
      }
    }
  }, [_vm._v("\n                        Se alle synsrapporter\n                        "), (_vm.$store.state.carData.inspection.Rapporter && _vm.$store.state.carData.inspection.Rapporter.length > 0) ? _c('span', [_vm._v("\n                            (" + _vm._s(_vm.$store.state.carData.inspection.Rapporter.length) + ")\n                        ")]) : _vm._e(), _vm._v(" "), _c('i', {
    staticClass: "fas fa-chevron-right"
  })])], 1) : _c('data-loader', {
    attrs: {
      "title": "Henter data fra Trafikstyrelsen"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "column column__third"
  }, [_c('div', {
    staticClass: "block fullheight animated fadeIn delay-1s"
  }, [_vm._m(2), _vm._v(" "), (!_vm.$store.state.loadingDmr) ? _c('div', {
    staticClass: "body"
  }, [(_vm.$store.state.carData.dmr.Afgift.AfgiftDetaljer.length > 0) ? _c('div', [(_vm.$store.state.carData.dmr.Afgift.AfgiftDetaljer.length > 0 && _vm.$store.state.carData.dmr.Afgift.AfgiftDetaljer[0].Hyppighed === 'Halvårlig') ? _c('line-data', {
    attrs: {
      "title": "Halvårlig afgift",
      "value": _vm.$store.state.carData.dmr.Afgift.AfgiftDetaljer[_vm.$store.state.carData.dmr.Afgift.AfgiftDetaljer.length - 1].Pris
    }
  }) : _vm._e(), _vm._v(" "), (_vm.$store.state.carData.dmr.Afgift.AfgiftDetaljer.length === 0 && _vm.$store.state.carData.dmr.Afgift.AfgiftDetaljer[0].Hyppighed === 'Halvårlig') ? _c('line-data', {
    attrs: {
      "title": "Halvårlig afgift",
      "value": _vm.$store.state.carData.dmr.Afgift.AfgiftDetaljer[_vm.$store.state.carData.dmr.Afgift.AfgiftDetaljer.length - 1].Pris
    }
  }) : _vm._e(), _vm._v(" "), (_vm.$store.state.carData.dmr.Afgift.AfgiftDetaljer.length > 0 && _vm.$store.state.carData.dmr.Afgift.AfgiftDetaljer[0].Hyppighed === 'Årlig') ? _c('line-data', {
    attrs: {
      "title": "Årlig afgift",
      "value": _vm.$store.state.carData.dmr.Afgift.AfgiftDetaljer[_vm.$store.state.carData.dmr.Afgift.AfgiftDetaljer.length - 1].Pris
    }
  }) : _vm._e(), _vm._v(" "), (_vm.$store.state.carData.dmr.Afgift.AfgiftDetaljer.length === 0 && _vm.$store.state.carData.dmr.Afgift.AfgiftDetaljer[0].Hyppighed === 'Årlig') ? _c('line-data', {
    attrs: {
      "title": "Årlig afgift",
      "value": _vm.$store.state.carData.dmr.Afgift.AfgiftDetaljer[_vm.$store.state.carData.dmr.Afgift.AfgiftDetaljer.length - 1].Pris
    }
  }) : _vm._e(), _vm._v(" "), _c('line-data', {
    attrs: {
      "title": "Næste afgift om",
      "value": _vm.daysUntilNextCharge,
      "suffix": "dage"
    }
  }), _vm._v(" "), _c('router-link', {
    staticClass: "block-cta",
    attrs: {
      "tag": "div",
      "to": {
        name: 'SearchCharges'
      }
    },
    nativeOn: {
      "click": function($event) {
        return _vm.$scrollToTop($event)
      }
    }
  }, [_vm._v("\n                            Se alle opkrævede afgifter\n                            "), (_vm.$store.state.carData.dmr.Afgift && _vm.$store.state.carData.dmr.Afgift.OpkraevedeAfgifter.length > 0) ? _c('span', [_vm._v("\n                                (" + _vm._s(_vm.$store.state.carData.dmr.Afgift.OpkraevedeAfgifter.length) + ")\n                            ")]) : _vm._e(), _vm._v(" "), _c('i', {
    staticClass: "fas fa-chevron-right"
  })])], 1) : _c('div', [_vm._v("\n                        Ingen afgiftsoplysninger\n                    ")])]) : _c('data-loader', {
    attrs: {
      "title": "Henter data fra Motorregistret"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "column column__small"
  }, [_c('div', {
    staticClass: "block fullheight animated fadeIn delay-1s"
  }, [_vm._m(3), _vm._v(" "), (!_vm.$store.state.loadingDmr) ? _c('div', {
    staticClass: "body align-top"
  }, [(_vm.$store.state.carData.dmr.Forsikring.Status !== null) ? _c('div', [_c('b', {
    staticStyle: {
      "display": "block",
      "margin-bottom": "15px"
    }
  }, [_vm._v(_vm._s(_vm.$store.state.carData.dmr.Forsikring.Selskab))]), _vm._v(" "), (_vm.$store.state.carData.dmr.Forsikring !== null && _vm.$store.state.carData.dmr.Forsikring.Status !== 'Aktiv') ? _c('line-data', {
    attrs: {
      "title": "Status",
      "value": _vm.$store.state.carData.dmr.Forsikring.Status
    }
  }) : _c('line-data', {
    attrs: {
      "title": "Oprettet",
      "value": _vm._f("moment")(_vm.insuranceDate, 'D. MMM. YYYY')
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "block-cta",
    on: {
      "click": function($event) {
        _vm.goToInsurancePartner('Samlino (link)')
      }
    }
  }, [_vm._v("\n                            Beregn din forsikringspris\n                            "), _c('i', {
    staticClass: "fas fa-external-link"
  })])], 1) : _vm._e(), _vm._v(" "), (_vm.$store.state.carData.dmr.Forsikring.Status === null) ? _c('div', [_vm._v("\n                        Ingen forsikringsoplysninger\n                        "), _c('br'), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "block-cta",
    on: {
      "click": function($event) {
        _vm.goToInsurancePartner('Samlino (link)')
      }
    }
  }, [_vm._v("\n                            Beregn din forsikringspris\n                            "), _c('i', {
    staticClass: "fas fa-external-link"
  })])]) : _vm._e()]) : _c('data-loader', {
    attrs: {
      "title": "Henter data fra Motorregistret"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "column column__small mobile-partner animated fadeIn delay-1s",
    on: {
      "click": function($event) {
        _vm.goToInsurancePartner('Samlino (mobil billede)')
      }
    }
  }, [_vm._m(4)])]), _vm._v(" "), _c('div', {
    staticClass: "content-layout"
  }, [_c('div', {
    staticClass: "column column__medium"
  }, [_c('div', {
    staticClass: "block fullheight animated fadeIn delay-2s"
  }, [_vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "body"
  }, [_c('line-data', {
    attrs: {
      "title": "Brændstofforbrug",
      "value": _vm.$store.state.carData.general.MotorKmPerLiter,
      "suffix": "km/l"
    }
  }), _vm._v(" "), (_vm.$store.state.carData.general.DrivkraftTypeNavn === 'El') ? _c('line-data', {
    attrs: {
      "title": "Elektrisk forbrug",
      "value": _vm.$store.state.carData.general.MotorElektriskForbrug,
      "suffix": "Wh/km"
    }
  }) : _vm._e(), _vm._v(" "), _c('line-data', {
    attrs: {
      "title": "Brændstof type",
      "value": _vm.$store.state.carData.general.DrivkraftTypeNavn
    }
  }), _vm._v(" "), _c('line-data', {
    attrs: {
      "title": "Antal cylindre",
      "value": _vm.$store.state.carData.general.MotorCylinderAntal
    }
  }), _vm._v(" "), _c('line-data', {
    attrs: {
      "title": "Slagvolumen",
      "value": _vm.$store.state.carData.general.MotorSlagVolumen,
      "suffix": "cm<sup>3</sup>"
    }
  }, [(_vm.$store.state.carData.general.MotorStoerrelse) ? _c('span', {
    attrs: {
      "slot": "extra"
    },
    slot: "extra"
  }, [_vm._v("\n                            (" + _vm._s(_vm.$store.state.carData.general.MotorStoerrelse) + "L)\n                        ")]) : _vm._e()]), _vm._v(" "), _c('line-data', {
    attrs: {
      "title": "Hestekræfter",
      "value": _vm._f("rounded")(_vm.$store.state.carData.general.MotorStoersteEffekt * 1.3636363636),
      "suffix": "HK"
    }
  }), _vm._v(" "), _c('line-data', {
    attrs: {
      "title": "Max hastighed",
      "value": _vm.$store.state.carData.general.MaksimumHastighed,
      "suffix": "km/t"
    }
  }), _vm._v(" "), _c('router-link', {
    staticClass: "block-cta",
    attrs: {
      "tag": "div",
      "to": {
        name: 'SearchTechnicalInfo'
      }
    },
    nativeOn: {
      "click": function($event) {
        return _vm.$scrollToTop($event)
      }
    }
  }, [_vm._v("\n                        Se alle tekniske specifikationer\n                        "), _c('i', {
    staticClass: "fas fa-chevron-right"
  })])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "column column__medium"
  }, [_c('div', {
    staticClass: "block fullheight animated fadeIn delay-2s",
    staticStyle: {
      "position": "relative"
    }
  }, [_c('div', {
    staticClass: "economy-fields-toggle absolute"
  }, [(!_vm.showEconomyFields) ? _c('div', {
    on: {
      "click": function($event) {
        _vm.showEconomyFields = true
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-pencil"
  }), _vm._v("\n                        Beregn din økonomi\n                    ")]) : _vm._e()]), _vm._v(" "), _vm._m(6), _vm._v(" "), _c('div', {
    staticClass: "body economy"
  }, [(!_vm.showEconomyFields) ? _c('div', [_c('div', {
    staticClass: "economy-fields-toggle mobile"
  }, [(!_vm.showEconomyFields) ? _c('div', {
    on: {
      "click": function($event) {
        _vm.showEconomyFields = true
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-pencil"
  }), _vm._v("\n                                Beregn din økonomi\n                            ")]) : _vm._e()]), _vm._v(" "), _c('line-data', {
    attrs: {
      "title": "Brændstof",
      "value": _vm._f("currency")(_vm.totalFuel),
      "suffix": "kr."
    }
  }), _vm._v(" "), _c('line-data', {
    attrs: {
      "title": "Service & vedligeholdelse",
      "value": _vm._f("currency")(_vm.totalMaintenance),
      "suffix": "kr."
    }
  }), _vm._v(" "), _c('line-data', {
    attrs: {
      "title": "Forsikring",
      "value": _vm._f("currency")(_vm.totalInsurance),
      "suffix": "kr."
    }
  }), _vm._v(" "), _c('line-data', {
    attrs: {
      "title": "Afgift",
      "value": _vm._f("currency")(_vm.totalCharges),
      "suffix": "kr."
    }
  }), _vm._v(" "), (_vm.calculator.monthlyLoan > 0) ? _c('line-data', {
    attrs: {
      "title": "Afdrag på lån",
      "value": _vm._f("currency")(_vm.calculator.monthlyLoan),
      "suffix": "kr."
    }
  }) : _vm._e(), _vm._v(" "), _c('line-data', {
    staticClass: "big-text",
    attrs: {
      "title": "Total pr. måned",
      "value": _vm._f("currency")(_vm.totalExpensePerMonth),
      "suffix": "kr."
    }
  }), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticStyle: {
      "opacity": ".5",
      "font-size": "12px"
    }
  }, [_vm._v("\n                            Beregningerne er baseret på den gennemsnitlige danskers kørselsvaner og udgifter sammenholdt med dette køretøjs data.\n                        ")])], 1) : _c('div', {
    staticClass: "budget"
  }, [_c('line-data', {
    attrs: {
      "title": "Km kørt pr. år",
      "value": "donotshow",
      "alignCenter": true,
      "type": "km"
    }
  }, [_c('div', {
    attrs: {
      "slot": "extra"
    },
    slot: "extra"
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.calculator.kmPerYear),
      expression: "calculator.kmPerYear"
    }],
    staticClass: "form-control type-km",
    attrs: {
      "slot": "extra",
      "type": "number",
      "min": "0",
      "max": "100000",
      "step": "1000",
      "inputmode": "numeric",
      "pattern": "[0-9]*"
    },
    domProps: {
      "value": (_vm.calculator.kmPerYear)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.calculator, "kmPerYear", $event.target.value)
      }
    },
    slot: "extra"
  })]), _vm._v(" "), _c('line-data', {
    attrs: {
      "title": "Service & vedl. pr. km (kr.)",
      "value": "donotshow",
      "alignCenter": true,
      "type": "kr"
    }
  }, [_c('div', {
    attrs: {
      "slot": "extra"
    },
    slot: "extra"
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.calculator.maintenancePerKm),
      expression: "calculator.maintenancePerKm"
    }],
    staticClass: "form-control",
    attrs: {
      "slot": "extra",
      "type": "number",
      "min": "0",
      "max": "1",
      "step": "0.10",
      "inputmode": "numeric",
      "pattern": "[0-9]*"
    },
    domProps: {
      "value": (_vm.calculator.maintenancePerKm)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.calculator, "maintenancePerKm", $event.target.value)
      }
    },
    slot: "extra"
  })]), _vm._v(" "), _c('line-data', {
    attrs: {
      "title": "Årlig forsikring (kr.)",
      "value": "donotshow",
      "alignCenter": true,
      "type": "kr"
    }
  }, [_c('div', {
    attrs: {
      "slot": "extra"
    },
    slot: "extra"
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.calculator.insurance),
      expression: "calculator.insurance"
    }],
    staticClass: "form-control",
    attrs: {
      "slot": "extra",
      "type": "number",
      "min": "0",
      "max": "100000",
      "step": "1000",
      "inputmode": "numeric",
      "pattern": "[0-9]*"
    },
    domProps: {
      "value": (_vm.calculator.insurance)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.calculator, "insurance", $event.target.value)
      }
    },
    slot: "extra"
  }), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "newline"
    },
    slot: "newline"
  }, [_c('a', {
    staticClass: "block-cta",
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        _vm.goToInsurancePartner('Samlino (Økonomi link)')
      }
    }
  }, [_vm._v("\n                                    Beregn din forsikringspris\n                                    "), _c('i', {
    staticClass: "fas fa-external-link"
  })])])]), _vm._v(" "), _c('line-data', {
    attrs: {
      "title": "Afdrag på lån pr. måned (kr.)",
      "value": "donotshow",
      "alignCenter": true,
      "type": "kr"
    }
  }, [_c('div', {
    attrs: {
      "slot": "extra"
    },
    slot: "extra"
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.calculator.monthlyLoan),
      expression: "calculator.monthlyLoan"
    }],
    staticClass: "form-control",
    attrs: {
      "slot": "extra",
      "type": "number",
      "min": "0",
      "max": "30000",
      "step": "500",
      "inputmode": "numeric",
      "pattern": "[0-9]*"
    },
    domProps: {
      "value": (_vm.calculator.monthlyLoan)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.calculator, "monthlyLoan", $event.target.value)
      }
    },
    slot: "extra"
  }), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "newline"
    },
    slot: "newline"
  }, [_c('a', {
    staticClass: "block-cta",
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        return _vm.goToLoanPartner('Økonomi link')
      }
    }
  }, [(_vm.$store.state.carData.general.KoeretoejArtNavn === 'Motorcykel') ? _c('span', [_vm._v("\n                                        Beregn dit MC-lån\n                                        "), _c('i', {
    staticClass: "fas fa-external-link"
  })]) : _c('span', [_vm._v("\n                                        Beregn dit billån\n                                        "), _c('i', {
    staticClass: "fas fa-external-link"
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "economy-fields-toggle",
    on: {
      "click": function($event) {
        _vm.showEconomyFields = false
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-save"
  }), _vm._v("\n                            Gem og vis resultat\n                        ")])], 1)])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title"
  }, [_c('i', {
    staticClass: "fal fa-clipboard-check fa-fw"
  }), _vm._v("\n                    Tjekliste\n                ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title"
  }, [_c('i', {
    staticClass: "fal fa-clipboard-list-check fa-fw"
  }), _vm._v("\n                    Syn\n                ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title"
  }, [_c('i', {
    staticClass: "fal fa-envelope-open-dollar fa-fw"
  }), _vm._v("\n                    Afgift\n                ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title"
  }, [_c('i', {
    staticClass: "fal fa-file-certificate fa-fw"
  }), _vm._v("\n                    Forsikring\n                ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "block"
  }, [_c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": "/static/partners/samlino-500x500.jpg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title"
  }, [_c('i', {
    staticClass: "fal fa-cog fa-fw"
  }), _vm._v("\n                    Motor\n                ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title"
  }, [_c('i', {
    staticClass: "fal fa-sack-dollar fa-fw"
  }), _vm._v("\n                    Økonomi\n                ")])
}]}

/***/ }),
/* 353 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "landing"
  }, [_c('div', {
    staticClass: "hero"
  }, [_c('div', {
    staticClass: "search-wrapper"
  }, [_vm._m(0), _vm._v(" "), _c('form', {
    attrs: {
      "action": "."
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.doSearch()
      }
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.licenseplate),
      expression: "licenseplate"
    }],
    ref: "tester",
    staticClass: "hero-search animated fadeInUp delay-1s",
    attrs: {
      "type": "search",
      "placeholder": "AL 52 114",
      "maxlength": "9"
    },
    domProps: {
      "value": (_vm.licenseplate)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.licenseplate = $event.target.value
      }
    }
  }), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('button', {
    staticClass: "animated fadeIn delay-2s",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("\n                    Søg\n                ")])]), _vm._v(" "), (_vm.vehicles.length > 0) ? _c('div', {
    staticClass: "animated fadeIn delay-5s",
    on: {
      "click": function($event) {
        return _vm.goToRandomLicenseplate()
      }
    }
  }, [_c('br'), _vm._v(" "), _c('div', {
    staticStyle: {
      "color": "#fff"
    }
  }, [_vm._v("eller")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "random-button"
  }, [_vm._v("\n                    Slå tilfældig nummerplade op\n                ")])]) : _vm._e()])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title-block animated fadeIn"
  }, [_c('h1', [_vm._v("\n                    Gratis nummerpladetjek\n                ")]), _vm._v("\n                Se bl.a. synsrapporter, restgæld, forsikring, afgifter mv.\n                ")])
}]}

/***/ }),
/* 354 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "line",
    class: {
      'wide': _vm.wide && _vm.wide === true, 'align-center': _vm.alignCenter
    }
  }, [_c('div', {
    staticClass: "line__title"
  }, [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.title)
    }
  }), _vm._v(" "), _vm._t("newline")], 2), _vm._v(" "), (_vm.value && _vm.value !== null) ? _c('div', {
    staticClass: "line__value type",
    class: 'type-' + _vm.type
  }, [(_vm.value === false) ? _c('span', [_vm._v("Nej")]) : _vm._e(), _vm._v(" "), (_vm.value === true) ? _c('span', [_vm._v("Ja")]) : _vm._e(), _vm._v(" "), (_vm.value !== true && _vm.value !== false && _vm.value !== 'donotshow') ? _c('span', [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.value)
    }
  }), _vm._v(" "), (_vm.suffix) ? _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.suffix)
    }
  }) : _vm._e()]) : _vm._e(), _vm._v(" "), _vm._t("extra")], 2) : _c('div', {
    staticClass: "line__value"
  }, [_vm._v("\n        -\n    ")])])
},staticRenderFns: []}

/***/ }),
/* 355 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "data-loader"
  }, [_vm._v("\n    " + _vm._s(_vm.title) + "\n")])
},staticRenderFns: []}

/***/ }),
/* 356 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "offline-wrapper"
  }, [_c('div', {
    staticClass: "offline-inner"
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-exclamation-circle"
  })]), _vm._v(" "), _c('h1', [_vm._v("Whoops!")]), _vm._v(" "), _c('h3', [_vm._v("You've lost the connection to the internet.")]), _vm._v(" "), _c('p', {
    staticClass: "description"
  }, [_vm._v("We could not register a live connection to the internet. Since this application uses network functions, please make sure you have a valid network connection and try again.")]), _vm._v(" "), _c('p', [_c('a', {
    attrs: {
      "href": "/"
    }
  }, [_c('button', {
    staticClass: "btn btn-primary"
  }, [_vm._v("Refresh this page")])])])])])
}]}

/***/ }),
/* 357 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "index"
  }, [(_vm.loading) ? _c('div', {
    staticClass: "loader-wrapper"
  }, [_vm._m(0)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('form', {
    staticClass: "inputform",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.doSearch()
      }
    }
  }, [_c('div', {
    staticClass: "inner"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.licenseplate),
      expression: "licenseplate"
    }],
    attrs: {
      "type": "text",
      "placeholder": "Indtast nummerplade..."
    },
    domProps: {
      "value": (_vm.licenseplate)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.licenseplate = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Søg")])])]), _vm._v(" "), (!_vm.loading && _vm.vehicleData) ? _c('div', {
    staticClass: "vehicle-header animated fadeInUp"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "text"
  }, [_c('div', {
    staticClass: "make-model"
  }, [_vm._v("\n                    " + _vm._s(_vm.vehicleData.general.MaerkeTypeNavn) + "\n                    " + _vm._s(_vm.vehicleData.general.ModelTypeNavn) + "\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "variant"
  }, [_vm._v("\n                    " + _vm._s(_vm.vehicleData.general.VariantTypeNavn) + "\n                ")])])]) : _vm._e(), _vm._v(" "), (!_vm.loading && _vm.vehicleData) ? _c('div', {
    staticClass: "grid-layout animated fadeIn delay-1s"
  }, [_c('div', {
    staticClass: "main-area"
  }, [_c('div', {
    staticClass: "block"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n                        Generelt\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "body"
  }, [_c('div', {
    staticClass: "line"
  }, [_c('div', {
    staticClass: "line__title"
  }, [_vm._v("Model årgang")]), _vm._v(" "), _c('div', {
    staticClass: "line__value"
  }, [(_vm.vehicleData.general.ModelAar) ? _c('span', [_vm._v(_vm._s(_vm.vehicleData.general.ModelAar))]) : _c('span', [_vm._v("-")])])]), _vm._v(" "), _c('div', {
    staticClass: "line"
  }, [_c('div', {
    staticClass: "line__title"
  }, [_vm._v("Indregistreret")]), _vm._v(" "), _c('div', {
    staticClass: "line__value"
  }, [(_vm.vehicleData.general.FoersteRegistreringDato) ? _c('span', [_vm._v(_vm._s(_vm._f("moment")(_vm.vehicleData.general.FoersteRegistreringDato, 'D[.] MMMM YYYY')))]) : _c('span', [_vm._v("-")])])]), _vm._v(" "), _c('div', {
    staticClass: "line"
  }, [_c('div', {
    staticClass: "line__title"
  }, [_vm._v("Art")]), _vm._v(" "), _c('div', {
    staticClass: "line__value"
  }, [(_vm.vehicleData.general.KoeretoejArtNavn) ? _c('span', [_vm._v(_vm._s(_vm.vehicleData.general.KoeretoejArtNavn))]) : _c('span', [_vm._v("-")])])]), _vm._v(" "), _c('div', {
    staticClass: "line"
  }, [_c('div', {
    staticClass: "line__title"
  }, [_vm._v("Stelnummer")]), _vm._v(" "), _c('div', {
    staticClass: "line__value"
  }, [(_vm.vehicleData.general.StelNr) ? _c('span', [_vm._v(_vm._s(_vm.vehicleData.general.StelNr))]) : _c('span', [_vm._v("-")])])]), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "line"
  }, [_c('div', {
    staticClass: "line__title"
  }, [_vm._v("Status")]), _vm._v(" "), _c('div', {
    staticClass: "line__value"
  }, [(_vm.vehicleData.general.Status) ? _c('span', [_vm._v(_vm._s(_vm.vehicleData.general.Status))]) : _c('span', [_vm._v("-")])])]), _vm._v(" "), _c('div', {
    staticClass: "line"
  }, [_c('div', {
    staticClass: "line__title"
  }, [_vm._v("Nuværende ejer")]), _vm._v(" "), _c('div', {
    staticClass: "line__value"
  }, [(_vm.vehicleData.general.currentOwner) ? _c('span', [_vm._v(_vm._s(_vm.vehicleData.general.currentOwner))]) : _c('span', [_vm._v("-")])])]), _vm._v(" "), _c('div', {
    staticClass: "line"
  }, [_c('div', {
    staticClass: "line__title"
  }, [_vm._v("Motor")]), _vm._v(" "), _c('div', {
    staticClass: "line__value"
  }, [(_vm.vehicleData.general.MotorStoerrelse) ? _c('span', [_vm._v("\n                                    " + _vm._s(_vm.vehicleData.general.MotorStoerrelse) + "\n                                    (" + _vm._s(_vm.vehicleData.general.MotorSlagVolumen) + " ccm,\n                                    " + _vm._s(_vm.vehicleData.general.MotorCylinderAntal) + " cyl.,\n                                    " + _vm._s(_vm.vehicleData.general.DrivkraftTypeNavn) + ")\n                                ")]) : _c('span', [_vm._v("-")])])]), _vm._v(" "), _c('div', {
    staticClass: "line"
  }, [_c('div', {
    staticClass: "line__title"
  }, [_vm._v("Effekt")]), _vm._v(" "), _c('div', {
    staticClass: "line__value"
  }, [(_vm.vehicleData.general.MotorHestekraefter) ? _c('span', [_vm._v("\n                                    " + _vm._s(_vm.vehicleData.general.MotorHestekraefter) + " HK\n                                    (" + _vm._s(_vm.vehicleData.general.MotorStoersteEffekt) + " kW)\n                                ")]) : _c('span', [_vm._v("-")])])]), _vm._v(" "), _c('div', {
    staticClass: "line"
  }, [_c('div', {
    staticClass: "line__title"
  }, [_vm._v("Opgivet forbrug")]), _vm._v(" "), _c('div', {
    staticClass: "line__value"
  }, [(_vm.vehicleData.general.MotorKmPerLiter) ? _c('span', [_vm._v(_vm._s(_vm.vehicleData.general.MotorKmPerLiter) + " km/l")]) : _c('span', [_vm._v("-")])])]), _vm._v(" "), _c('div', {
    staticClass: "line"
  }, [_c('div', {
    staticClass: "line__title"
  }, [_vm._v("Fælge / dæk")]), _vm._v(" "), _c('div', {
    staticClass: "line__value"
  }, [(_vm.vehicleData.general.FaelgDaek) ? _c('span', [_vm._v(_vm._s(_vm.vehicleData.general.FaelgDaek))]) : _c('span', [_vm._v("-")])])]), _vm._v(" "), _c('div', {
    staticClass: "line"
  }, [_c('div', {
    staticClass: "line__title"
  }, [_vm._v("Sidst synet")]), _vm._v(" "), _c('div', {
    staticClass: "line__value"
  }, [(_vm.vehicleData.dmr.SidsteSyn) ? _c('span', [_vm._v("\n                                    " + _vm._s(_vm._f("moment")(_vm.vehicleData.dmr.SidsteSyn, 'D[.] MMMM YYYY')) + "\n                                ")]) : _c('span', [_vm._v("\n                                    Køretøjet har ikke været synet endnu\n                                ")])])]), _vm._v(" "), _c('div', {
    staticClass: "line"
  }, [_c('div', {
    staticClass: "line__title"
  }, [_vm._v("Næste syn")]), _vm._v(" "), _c('div', {
    staticClass: "line__value"
  }, [(_vm.vehicleData.dmr.NaesteSyn) ? _c('span', [_vm._v(_vm._s(_vm._f("moment")(_vm.vehicleData.dmr.NaesteSyn, 'D[.] MMMM YYYY')))]) : _c('span', [_vm._v("-")])])]), _vm._v(" "), _c('div', {
    staticClass: "line"
  }, [_c('div', {
    staticClass: "line__title"
  }, [_vm._v("Afgift")]), _vm._v(" "), _c('div', {
    staticClass: "line__value"
  }, [(_vm.vehicleData.dmr.Afgift.AfgiftDetaljer.length > 0) ? _c('span', _vm._l((_vm.vehicleData.dmr.Afgift.AfgiftDetaljer), function(afgift) {
    return (afgift.AfgiftType === 'Sum') ? _c('span', {
      key: afgift.AfgiftType
    }, [_vm._v("\n                                        " + _vm._s(afgift.Pris) + " / halvårlig\n                                    ")]) : _vm._e()
  }), 0) : _c('span', [_vm._v("-")])])]), _vm._v(" "), _c('div', {
    staticClass: "line"
  }, [_c('div', {
    staticClass: "line__title"
  }, [_vm._v("Udstyr")]), _vm._v(" "), _c('div', {
    staticClass: "line__value"
  }, [(_vm.vehicleData.general.KoeretoejUdstyrSamling.length > 0) ? _c('span', _vm._l((_vm.vehicleData.general.KoeretoejUdstyrSamling), function(feature) {
    return _c('div', {
      key: feature,
      staticClass: "single-feature"
    }, [_vm._v("\n                                        " + _vm._s(feature) + "\n                                    ")])
  }), 0) : _c('span', [_vm._v("-")])])]), _vm._v(" "), (_vm.vehicleData.stats.SimilarCarsCount && _vm.vehicleData.general.ModelAar && _vm.vehicleData.general.ModelAar !== '-') ? _c('div', {
    staticClass: "line line__fw"
  }, [_vm._v("\n                            Der er "), _c('span', {
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_vm._v(" " + _vm._s(_vm.vehicleData.stats.SimilarCarsCount) + " ")]), _vm._v(" " + _vm._s(_vm.vehicleData.general.MaerkeTypeNavn) + " " + _vm._s(_vm.vehicleData.general.ModelTypeNavn)), (_vm.vehicleData.general.ModelAar && _vm.vehicleData.general.ModelAar !== '-') ? _c('span', [_vm._v(", årgang " + _vm._s(_vm.vehicleData.general.ModelAar) + " ")]) : _vm._e(), _vm._v("indregistreret i DK\n                        ")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "block"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n                        Gæld / Bilbogen\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "body"
  }, [(_vm.vehicleData.registry.LaaneDokumenter.length === 0) ? _c('div', [_vm._v("\n                            Der er ikke registreret gæld i køretøjet\n                        ")]) : _vm._e(), _vm._v(" "), (_vm.vehicleData.registry && _vm.vehicleData.registry.LaaneDokumenter.length > 0) ? _c('div', [_c('div', {
    staticClass: "line"
  }, [_c('div', {
    staticClass: "line__title"
  }, [_vm._v("Hvem skylder")]), _vm._v(" "), _c('div', {
    staticClass: "line__value"
  }, [_vm._v("\n                                    " + _vm._s(_vm.vehicleData.registry.LaaneDokumenter[0].Debitorer[0].Navn) + "\n                                    "), _c('br'), _vm._v("\n                                    CPR: " + _vm._s(_vm.vehicleData.registry.LaaneDokumenter[0].Debitorer[0].FoedselsDato) + " (XX år)\n                                ")])]), _vm._v(" "), _c('div', {
    staticClass: "line"
  }, [_c('div', {
    staticClass: "line__title"
  }, [_vm._v("Stelnummer")]), _vm._v(" "), _c('div', {
    staticClass: "line__value"
  }, [_vm._v("\n                                    " + _vm._s(_vm.vehicleData.general.StelNr) + "\n                                ")])]), _vm._v(" "), _c('div', {
    staticClass: "line"
  }, [_c('div', {
    staticClass: "line__title"
  }, [_vm._v("Oprindelige lån")]), _vm._v(" "), _c('div', {
    staticClass: "line__value"
  }, [_vm._v("\n                                    " + _vm._s(_vm.vehicleData.registry.LaaneDokumenter[0].HovedStol) + "\n                                ")])]), _vm._v(" "), _c('div', {
    staticClass: "line"
  }, [_c('div', {
    staticClass: "line__title"
  }, [_vm._v("Kreditor")]), _vm._v(" "), _c('div', {
    staticClass: "line__value"
  }, [_vm._v("\n                                    " + _vm._s(_vm.vehicleData.registry.LaaneDokumenter[0].Underpanthaver) + "\n                                ")])]), _vm._v(" "), (_vm.vehicleData.registry.LaaneDokumenter[0].Underpanthaver) ? _c('div', {
    staticClass: "line"
  }, [_c('div', {
    staticClass: "line__title"
  }, [_vm._v("Bemærkninger")]), _vm._v(" "), _c('div', {
    staticClass: "line__value"
  }, _vm._l((_vm.vehicleData.registry.LaaneDokumenter[0].TillaegsTekster), function(attention) {
    return _c('div', [_vm._v("\n                                        " + _vm._s(attention) + "\n                                    ")])
  }), 0)]) : _vm._e()]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "block"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n                        Økonomi / beregner\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "body"
  }, [_vm._v("\n                        Antagelser: 11 kr. per liter benzin\n                        "), _c('br'), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "line line__df"
  }, [_c('div', {
    staticClass: "line__title"
  }, [_vm._v("Antal km om året")]), _vm._v(" "), _c('div', {
    staticClass: "line__val"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.calculator.kmPerYear),
      expression: "calculator.kmPerYear"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "min": "0",
      "max": "150000"
    },
    domProps: {
      "value": (_vm.calculator.kmPerYear)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.calculator, "kmPerYear", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "line line__df"
  }, [_c('div', {
    staticClass: "line__title"
  }, [_vm._v("Service / reparation pr. 100 km")]), _vm._v(" "), _c('div', {
    staticClass: "line__val"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.calculator.expensePerHundredKm),
      expression: "calculator.expensePerHundredKm"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "min": "0",
      "max": "100"
    },
    domProps: {
      "value": (_vm.calculator.expensePerHundredKm)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.calculator, "expensePerHundredKm", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "line line__df"
  }, [_c('div', {
    staticClass: "line__title"
  }, [_vm._v("Evt. afbetaling pr. måned")]), _vm._v(" "), _c('div', {
    staticClass: "line__val"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.calculator.payoff),
      expression: "calculator.payoff"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "min": "0",
      "max": "100000"
    },
    domProps: {
      "value": (_vm.calculator.payoff)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.calculator, "payoff", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "line line__df"
  }, [_c('div', {
    staticClass: "line__title"
  }, [_vm._v("Forsikring pr. år")]), _vm._v(" "), _c('div', {
    staticClass: "line__val"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.calculator.insurance),
      expression: "calculator.insurance"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "min": "0",
      "max": "100000"
    },
    domProps: {
      "value": (_vm.calculator.insurance)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.calculator, "insurance", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('hr'), _vm._v(" "), _vm._m(4), _vm._v(" "), _vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "line line__df"
  }, [_c('div', {
    staticClass: "line__title"
  }, [_vm._v("Afbetaling")]), _vm._v(" "), _c('div', {
    staticClass: "line__value"
  }, [_vm._v(_vm._s(_vm.calculator.payoff) + " kr.")])]), _vm._v(" "), _c('div', {
    staticClass: "line line__df"
  }, [_c('div', {
    staticClass: "line__title"
  }, [_vm._v("Forsikring")]), _vm._v(" "), _c('div', {
    staticClass: "line__value"
  }, [_vm._v(_vm._s(_vm.calculator.insurance) + " kr.")])]), _vm._v("-->\n                        "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "line line__df"
  }, [_c('div', {
    staticClass: "line__title",
    staticStyle: {
      "font-size": "20px"
    }
  }, [_vm._v("Månedlig udgift")]), _vm._v(" "), _c('div', {
    staticClass: "line__value",
    staticStyle: {
      "font-size": "20px"
    }
  }, [_c('b', [_vm._v(_vm._s(_vm.monthlyExpense) + " kr.")])])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('i', [_vm._v("Beregneren tager ikke højde for afdrag på lån, service, reparationer og forsikring.")])])]), _vm._v(" "), _c('div', {
    staticClass: "block"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n                        Synsrapporter\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "body"
  }, [_vm._l((_vm.vehicleData.inspection.Rapporter), function(report) {
    return (_vm.vehicleData && _vm.vehicleData.inspection.Rapporter) ? _c('div', {
      staticClass: "line"
    }, [_c('div', {
      staticClass: "line__title"
    }, [_vm._v(_vm._s(report.Synsdato))]), _vm._v(" "), _c('div', {
      staticClass: "line__value"
    }, [_vm._v("\n                                " + _vm._s(report.Synsresultat) + "\n                                "), _c('br'), _vm._v(" "), _c('a', {
      attrs: {
        "href": "javascript:void(0)"
      }
    }, [_vm._v("\n                                    Vis synsrapport\n                                ")]), _vm._v(" "), (_vm.showInspectionReportModal && _vm.inspectionReport !== null) ? _c('div', {
      staticClass: "inspection-report"
    }, [_c('div', {
      staticClass: "inner"
    }, [_c('div', {
      staticClass: "header"
    }, [_c('div', {
      staticClass: "result"
    }, [_vm._v("\n                                                " + _vm._s(_vm.inspectionReport.Synsresultat) + "\n                                            ")]), _vm._v(" "), _c('div', {
      staticClass: "company"
    }, [_c('b', [_vm._v(_vm._s(_vm.inspectionReport.Firma))]), _vm._v(" "), _c('br'), _vm._v("\n                                                " + _vm._s(_vm.inspectionReport.Adresse) + "\n                                                "), _c('br'), _vm._v("\n                                                CVR: " + _vm._s(_vm.inspectionReport.Cvr) + "        \n                                            ")])]), _vm._v(" "), _c('div', {
      staticClass: "boxes"
    }, [_c('div', {
      staticClass: "box"
    }, [_c('div', {
      staticClass: "box__title"
    }, [_vm._v("\n                                                    Synsdato\n                                                ")]), _vm._v(" "), _c('div', {
      staticClass: "box__value"
    }, [_vm._v("\n                                                    " + _vm._s(_vm._f("moment")(_vm.inspectionReport.Synsdato, 'D[.] MMMM YYYY')) + "\n                                                ")])]), _vm._v(" "), _c('div', {
      staticClass: "box"
    }, [_c('div', {
      staticClass: "box__title"
    }, [_vm._v("\n                                                    Synstype\n                                                ")]), _vm._v(" "), _c('div', {
      staticClass: "box__value"
    }, [_vm._v("\n                                                    " + _vm._s(_vm.inspectionReport.Synstype) + "\n                                                ")])]), _vm._v(" "), _c('div', {
      staticClass: "box"
    }, [_c('div', {
      staticClass: "box__title"
    }, [_vm._v("\n                                                    Nummerplade\n                                                ")]), _vm._v(" "), _c('div', {
      staticClass: "box__value"
    }, [_vm._v("\n                                                    " + _vm._s(_vm.inspectionReport.RegNr) + "\n                                                ")])]), _vm._v(" "), _vm._m(6, true)]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h3', [_vm._v("Fejl")]), _vm._v(" "), (_vm.inspectionReport.Fejl.length > 0) ? _c('div', {
      staticClass: "error-wrapper"
    }, _vm._l((_vm.inspectionReport.Fejl), function(error) {
      return _c('div', {
        staticClass: "error"
      }, [_c('b', [_vm._v(_vm._s(error.Number))]), _vm._v("\n                                                " + _vm._s(error.Description) + "\n                                            ")])
    }), 0) : _c('div', [_vm._v("\n                                            Ingen fejl registreret.\n                                        ")])])]) : _vm._e()])]) : _vm._e()
  }), _vm._v(" "), (_vm.vehicleData.inspection.Rapporter.length === 0) ? _c('div', [_vm._v("\n                            Køretøjet har ikke været synet endnu\n                        ")]) : _vm._e()], 2)]), _vm._v(" "), _c('div', {
    staticClass: "block"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n                        Afgifter\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "body"
  }, [(_vm.vehicleData.dmr.Afgift.OpkraevedeAfgifter.length > 0) ? _c('div', {
    staticClass: "table"
  }, [_c('table', [_vm._m(7), _vm._v(" "), _c('tbody', _vm._l((_vm.vehicleData.dmr.Afgift.OpkraevedeAfgifter), function(afgift) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(afgift.RegNr))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(afgift.AfgiftType))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(afgift.DaekkerFra) + " - " + _vm._s(afgift.DaekkerTil))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(afgift.Pris))])])
  }), 0)])]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "sidebar-area"
  }, [(_vm.vehicleData && _vm.vehicleData.general.RegNr === 'AL52114') ? _c('img', {
    staticStyle: {
      "width": "100%",
      "margin-bottom": "30px",
      "border-radius": "5px",
      "box-shadow": "0px 5px 15px rgba(0,0,0,0.15)"
    },
    attrs: {
      "src": "https://www.nummerplade.net/apps/nummerplade/carimage/8848406975.jpg"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.vehicleData && _vm.vehicleData.general.RegNr === 'BP59902') ? _c('img', {
    staticStyle: {
      "width": "100%",
      "margin-bottom": "30px",
      "border-radius": "5px",
      "box-shadow": "0px 5px 15px rgba(0,0,0,0.15)"
    },
    attrs: {
      "src": "/static/xsr700.jpeg"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.vehicleData && _vm.vehicleData.general.RegNr !== 'AL52114' && _vm.vehicleData.general.RegNr !== 'BP59902') ? _c('img', {
    staticStyle: {
      "width": "100%",
      "margin-bottom": "30px",
      "border-radius": "5px",
      "box-shadow": "0px 5px 15px rgba(0,0,0,0.15)"
    },
    attrs: {
      "src": 'https://placehold.it/1200x799?text=' + _vm.vehicleData.general.MaerkeTypeNavn + ' ' + _vm.vehicleData.general.ModelTypeNavn + ' ' + _vm.vehicleData.general.VariantTypeNavn
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "block"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n                        Hurtigt tjek\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "body"
  }, [_vm._m(8), _vm._v(" "), _c('div', {
    staticClass: "single-check"
  }, [(_vm.vehicleData.registry.LaaneDokumenter.length > 0) ? _c('div', {
    staticClass: "inner bad"
  }, [_c('i', {
    staticClass: "fas fa-exclamation fa-fw"
  }), _vm._v("\n                                Der er registreret pant i køretøjet!\n                            ")]) : _vm._e(), _vm._v(" "), (_vm.vehicleData.general.LeasingPeriode) ? _c('div', {
    staticClass: "inner neutral"
  }, [_c('i', {
    staticClass: "fas fa-info fa-fw"
  }), _vm._v("\n                                Køretøjet er leaset\n                            ")]) : _vm._e(), _vm._v(" "), (_vm.vehicleData.registry.LaaneDokumenter.length === 0 && !_vm.vehicleData.general.LeasingPeriode) ? _c('div', {
    staticClass: "inner good"
  }, [_c('i', {
    staticClass: "fas fa-check fa-fw"
  }), _vm._v("\n                                Der er ikke registreret pant i køretøjet\n                            ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "single-check"
  }, [(_vm.vehicleData.inspection.Rapporter.length > 0 && _vm.vehicleData.inspection.Rapporter[0].Synsresultat === 'Godkendt') ? _c('div', {
    staticClass: "inner good"
  }, [_c('i', {
    staticClass: "fas fa-check fa-fw"
  }), _vm._v("\n                                Køretøjet bestod seneste syn\n                                ")]) : _vm._e(), _vm._v(" "), (_vm.vehicleData.inspection.Rapporter.length > 0 && _vm.vehicleData.inspection.Rapporter[0].Synsresultat !== 'Godkendt') ? _c('div', {
    staticClass: "inner bad"
  }, [_c('i', {
    staticClass: "fas fa-exclamation fa-fw"
  }), _vm._v("\n                                Køretøjet bestod ikke seneste syn\n                            ")]) : _vm._e(), _vm._v(" "), (_vm.vehicleData.inspection.Rapporter.length === 0) ? _c('div', {
    staticClass: "inner good"
  }, [_c('i', {
    staticClass: "fas fa-check fa-fw"
  }), _vm._v("\n                                Køretøjet har ikke været synet endnu\n                            ")]) : _vm._e()]), _vm._v(" "), _vm._m(9), _vm._v(" "), _c('div', {
    staticClass: "single-check"
  }, [(_vm.vehicleData.dmr.Forsikring.Status === 'Aktiv') ? _c('div', {
    staticClass: "inner good"
  }, [_c('i', {
    staticClass: "fas fa-check fa-fw"
  }), _vm._v("\n                                Køretøjet er forsikret\n                            ")]) : _c('div', {
    staticClass: "inner bad"
  }, [_c('i', {
    staticClass: "fas fa-exclamation fa-fw"
  }), _vm._v("\n                                Køretøjet er ikke forsikret\n                            ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "block"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n                        Forsikring\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "body"
  }, [_c('div', {
    staticClass: "line"
  }, [_c('div', {
    staticClass: "line__title"
  }, [_vm._v("Status")]), _vm._v(" "), _c('div', {
    staticClass: "line__value"
  }, [_vm._v(_vm._s(_vm.vehicleData.dmr.Forsikring.Status))])]), _vm._v(" "), _c('div', {
    staticClass: "line"
  }, [_c('div', {
    staticClass: "line__title"
  }, [_vm._v("Selskab")]), _vm._v(" "), _c('div', {
    staticClass: "line__value"
  }, [_vm._v(_vm._s(_vm.vehicleData.dmr.Forsikring.Selskab))])]), _vm._v(" "), _c('div', {
    staticClass: "line"
  }, [_c('div', {
    staticClass: "line__title"
  }, [_vm._v("Oprettet")]), _vm._v(" "), _c('div', {
    staticClass: "line__value"
  }, [_vm._v(_vm._s(_vm._f("moment")(_vm.vehicleData.dmr.Forsikring.Oprettet, 'D[.] MMMM YYYY')))])])])])])]) : _vm._e()])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "lds-ring"
  }, [_c('div'), _vm._v(" "), _c('div'), _vm._v(" "), _c('div'), _vm._v(" "), _c('div')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "logo"
  }, [_c('i', {
    staticClass: "fal fa-car fa-fw"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "line"
  }, [_c('div', {
    staticClass: "line__title"
  }, [_vm._v("Forsikring")]), _vm._v(" "), _c('div', {
    staticClass: "line__value"
  }, [_c('a', {
    attrs: {
      "href": "https://www.partner-ads.com/dk/klikbanner.php?partnerid=28784&bannerid=60068&htmlurl=https://www.findforsikring.dk/indhent-tilbud-mini/?bil1=on"
    }
  }, [_vm._v("Se forsikringspriser her")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "line"
  }, [_c('div', {
    staticClass: "line__title"
  }, [_vm._v("Finansiering")]), _vm._v(" "), _c('div', {
    staticClass: "line__value"
  }, [_c('a', {
    attrs: {
      "href": "javascript:void(0)"
    }
  }, [_vm._v("Se oversigt over lånemuligheder")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "line line__df"
  }, [_c('div', {
    staticClass: "line__title"
  }, [_vm._v("Brændstof")]), _vm._v(" "), _c('div', {
    staticClass: "line__value"
  }, [_vm._v("667 kr.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "line line__df"
  }, [_c('div', {
    staticClass: "line__title"
  }, [_vm._v("Service / reparation")]), _vm._v(" "), _c('div', {
    staticClass: "line__value"
  }, [_vm._v("379 kr.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box__title"
  }, [_vm._v("\n                                                    Kilometerstand\n                                                ")]), _vm._v(" "), _c('div', {
    staticClass: "box__value"
  }, [_vm._v("\n                                                    203.000 km\n                                                ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Reg.nr.")]), _vm._v(" "), _c('th', [_vm._v("Type")]), _vm._v(" "), _c('th', [_vm._v("Dækker fra/til")]), _vm._v(" "), _c('th', [_vm._v("Beløb")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "single-check"
  }, [_c('div', {
    staticClass: "inner good"
  }, [_c('i', {
    staticClass: "fas fa-check fa-fw"
  }), _vm._v("\n                                Køretøjet er ikke efterlyst\n                            ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "single-check"
  }, [_c('div', {
    staticClass: "inner good"
  }, [_c('i', {
    staticClass: "fas fa-check fa-fw"
  }), _vm._v("\n                                Ingen tegn på kilometerfusk\n                            ")])])
}]}

/***/ }),
/* 358 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "technical-info"
  }, [_c('div', {
    staticClass: "content-layout"
  }, [_c('div', {
    staticClass: "column column__medium"
  }, [_c('div', {
    staticClass: "block"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n                    Motor\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "body"
  }, [_c('line-data', {
    attrs: {
      "title": "Mærkning",
      "value": _vm.$store.state.carData.general.MotorMaerkning
    }
  }), _vm._v(" "), _c('line-data', {
    attrs: {
      "title": "Drivkraft",
      "value": _vm.$store.state.carData.general.DrivkraftTypeNavn
    }
  }), _vm._v(" "), _c('line-data', {
    attrs: {
      "title": "Brændstofforbrug",
      "value": _vm.$store.state.carData.general.MotorKmPerLiter,
      "suffix": "km/l"
    }
  }), _vm._v(" "), _c('line-data', {
    attrs: {
      "title": "Elektrisk forbrug",
      "value": _vm.$store.state.carData.general.MotorElektriskForbrug,
      "suffix": "km/l"
    }
  }), _vm._v(" "), _c('line-data', {
    attrs: {
      "title": "Max hastighed",
      "value": _vm.$store.state.carData.general.MaksimumHastighed,
      "suffix": "km/t"
    }
  }), _vm._v(" "), _c('line-data', {
    attrs: {
      "title": "Slagvolumen",
      "value": _vm.$store.state.carData.general.MotorSlagVolumen,
      "suffix": "cm<sup>3</sup>"
    }
  }, [(_vm.$store.state.carData.general.MotorStoerrelse) ? _c('span', {
    attrs: {
      "slot": "extra"
    },
    slot: "extra"
  }, [_vm._v("\n                            (" + _vm._s(_vm.$store.state.carData.general.MotorStoerrelse) + "L)\n                        ")]) : _vm._e()]), _vm._v(" "), _c('line-data', {
    attrs: {
      "title": "Største effekt",
      "value": _vm.$store.state.carData.general.MotorStoersteEffekt,
      "suffix": "kW"
    }
  }, [_c('span', {
    attrs: {
      "slot": "extra"
    },
    slot: "extra"
  }, [_vm._v("\n                            (~" + _vm._s(_vm._f("rounded")(_vm.$store.state.carData.general.MotorStoersteEffekt * 1.3636363636)) + " HK)\n                        ")])]), _vm._v(" "), _c('line-data', {
    attrs: {
      "title": "Antal cylindre",
      "value": _vm.$store.state.carData.general.MotorCylinderAntal
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "block"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n                    Vægt\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "body"
  }, [_c('line-data', {
    attrs: {
      "title": "Teknisk totalvægt",
      "value": _vm.$store.state.carData.general.TekniskTotalVaegt,
      "suffix": "kg"
    }
  }), _vm._v(" "), _c('line-data', {
    attrs: {
      "title": "Totalvægt",
      "value": _vm.$store.state.carData.general.TotalVaegt,
      "suffix": "kg"
    }
  }), _vm._v(" "), _c('line-data', {
    attrs: {
      "title": "Egenvægt",
      "value": _vm.$store.state.carData.general.EgenVaegt,
      "suffix": "kg"
    }
  }), _vm._v(" "), _c('line-data', {
    attrs: {
      "title": "Køreklar vægt (min.)",
      "value": _vm.$store.state.carData.general.KoereklarVaegtMinimum,
      "suffix": "kg"
    }
  }), _vm._v(" "), _c('line-data', {
    attrs: {
      "title": "Tilkoblingsmulighed",
      "value": _vm.$store.state.carData.general.Tilkoblingsmulighed
    }
  }), _vm._v(" "), _c('line-data', {
    attrs: {
      "title": "Vogntogsvægt",
      "value": _vm.$store.state.carData.general.VogntogVaegt,
      "suffix": "kg"
    }
  }), _vm._v(" "), _c('line-data', {
    attrs: {
      "title": "Påhængsvogn totalvægt",
      "value": _vm.$store.state.carData.general.PaahaengVognTotalVaegt,
      "suffix": "kg"
    }
  }), _vm._v(" "), _c('line-data', {
    attrs: {
      "title": "Påhængskøretøj med bremser",
      "value": _vm.$store.state.carData.general.TilkoblingsvaegtMedBremser,
      "suffix": "kg"
    }
  }), _vm._v(" "), _c('line-data', {
    attrs: {
      "title": "Påhængskøretøj uden bremser",
      "value": _vm.$store.state.carData.general.TilkoblingsvaegtUdenBremser,
      "suffix": "kg"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "block"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n                    Udstyr\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "body"
  }, [_vm._l((_vm.$store.state.carData.general.KoeretoejUdstyrSamling), function(equipment) {
    return (_vm.$store.state.carData.general.KoeretoejUdstyrSamling.length > 0) ? _c('div', {
      staticClass: "equipment"
    }, [_vm._v("\n                        " + _vm._s(equipment) + "\n                    ")]) : _vm._e()
  }), _vm._v(" "), (_vm.$store.state.carData.general.KoeretoejUdstyrSamling.length === 0) ? _c('div', [_vm._v("\n                        -\n                    ")]) : _vm._e()], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "column column__medium"
  }, [_c('div', {
    staticClass: "block"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n                    Aksler\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "body"
  }, [_c('line-data', {
    attrs: {
      "title": "Antal",
      "value": _vm.$store.state.carData.general.AkselAntal
    }
  }), _vm._v(" "), _c('line-data', {
    attrs: {
      "title": "Afstand",
      "value": _vm.$store.state.carData.general.AkselAfstand,
      "suffix": "mm"
    }
  }), _vm._v(" "), _c('line-data', {
    attrs: {
      "title": "Trækkende aksler",
      "value": _vm.$store.state.carData.general.TraekkendeAksler
    }
  }), _vm._v(" "), _c('line-data', {
    attrs: {
      "title": "Største tryk",
      "value": _vm.$store.state.carData.general.StoersteAkselTryk,
      "suffix": "kg"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "block"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n                    Karrosseri\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "body"
  }, [_c('line-data', {
    attrs: {
      "title": "Type",
      "value": _vm.$store.state.carData.general.KarrosseriTypeNavn
    }
  }), _vm._v(" "), _c('line-data', {
    attrs: {
      "title": "Antal døre",
      "value": _vm.$store.state.carData.general.AntalDoere
    }
  }), _vm._v(" "), _c('line-data', {
    attrs: {
      "title": "Siddepladser (min.)",
      "value": _vm.$store.state.carData.general.SiddepladserMinimum
    }
  }), _vm._v(" "), _c('line-data', {
    attrs: {
      "title": "Fælge / dæk",
      "value": _vm.$store.state.carData.general.FaelgDaek
    }
  }), _vm._v(" "), _c('line-data', {
    attrs: {
      "title": "Sporvidde (forrest)",
      "value": _vm.$store.state.carData.general.SporviddenForrest,
      "suffix": "mm"
    }
  }), _vm._v(" "), _c('line-data', {
    attrs: {
      "title": "Sporvidde (bagerst)",
      "value": _vm.$store.state.carData.general.SporviddenBagest,
      "suffix": "mm"
    }
  }), _vm._v(" "), _c('line-data', {
    attrs: {
      "title": "Placering af stelnummer",
      "value": _vm.$store.state.carData.general.StelNummerAnbringelse
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "block"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n                    Miljøoplysninger\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "body"
  }, [_c('line-data', {
    attrs: {
      "title": "CO<sub>2</sub>-udslip",
      "value": _vm.$store.state.carData.general.MiljoeOplysningCO2Udslip,
      "suffix": "g"
    }
  }), _vm._v(" "), _c('line-data', {
    attrs: {
      "title": "CO",
      "value": _vm.$store.state.carData.general.MiljoeOplysningEmissionCO,
      "suffix": "g/km"
    }
  }), _vm._v(" "), _c('line-data', {
    attrs: {
      "title": "HC+NOX",
      "value": _vm.$store.state.carData.general.MiljoeOplysningEmissionHCPlusNOX,
      "suffix": "g/km"
    }
  }), _vm._v(" "), _c('line-data', {
    attrs: {
      "title": "NOX",
      "value": _vm.$store.state.carData.general.MiljoeOplysningEmissionHCPlusNOX,
      "suffix": "g/km"
    }
  }), _vm._v(" "), _c('line-data', {
    attrs: {
      "title": "Partikelfilter",
      "value": _vm.$store.state.carData.general.MiljoeOplysningPartikelFilter
    }
  }), _vm._v(" "), _c('line-data', {
    attrs: {
      "title": "Røgtæthed",
      "value": _vm.$store.state.carData.general.MiljoeOplysningRoegtaethed,
      "suffix": "m-1"
    }
  }, [(_vm.$store.state.carData.general.MiljoeOplysningRoegtaethedOmdrejningstal > 0) ? _c('span', {
    attrs: {
      "slot": "extra"
    },
    slot: "extra"
  }, [_vm._v("\n                            v. " + _vm._s(_vm.$store.state.carData.general.MiljoeOplysningRoegtaethedOmdrejningstal) + " o/m\n                        ")]) : _vm._e()]), _vm._v(" "), _c('line-data', {
    attrs: {
      "title": "Partikler",
      "value": _vm.$store.state.carData.general.MiljoeOplysningPartikler,
      "suffix": "g/km"
    }
  }), _vm._v(" "), _c('line-data', {
    attrs: {
      "title": "Kørselsstøj",
      "value": _vm.$store.state.carData.general.MotorKoerselStoej,
      "suffix": "dB"
    }
  }), _vm._v(" "), _c('line-data', {
    attrs: {
      "title": "Standstøj",
      "value": _vm.$store.state.carData.general.MotorStandStoej,
      "suffix": "dB"
    }
  }, [(_vm.$store.state.carData.general.MotorStandStoejOmdrejningstal > 0) ? _c('span', {
    attrs: {
      "slot": "extra"
    },
    slot: "extra"
  }, [_vm._v("\n                            v. " + _vm._s(_vm.$store.state.carData.general.MotorStandStoejOmdrejningstal) + " o/m\n                        ")]) : _vm._e()]), _vm._v(" "), _c('line-data', {
    attrs: {
      "title": "Euronorm",
      "value": _vm.$store.state.carData.general.NormTypeNavn
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "block"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n                    Sikkerhed\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "body"
  }, [_c('div', {
    staticClass: "line"
  }, [_c('div', {
    staticClass: "line__title"
  }, [_vm._v("\n                            Euro NCAP testet\n                        ")]), _vm._v(" "), _c('div', {
    staticClass: "line__value"
  }, [(_vm.$store.state.carData.general.NCAPTest) ? _c('span', [_vm._v("Ja")]) : _c('span', [_vm._v("Nej")])])]), _vm._v(" "), (_vm.$store.state.carData.general.NCAPTest) ? _c('div', [_c('a', {
    staticClass: "block-cta",
    staticStyle: {
      "font-weight": "600",
      "color": "#00c3ae"
    },
    attrs: {
      "href": 'https://www.euroncap.com/en/search-results/?query=' + _vm.$store.state.carData.general.MaerkeTypeNavn + '+' + _vm.$store.state.carData.general.ModelTypeNavn,
      "target": "_blank",
      "rel": "noopener"
    }
  }, [_vm._v("\n                            Søg efter NCAP test her\n                        ")])]) : _vm._e()])])])])])
},staticRenderFns: []}

/***/ }),
/* 359 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "reports"
  }, [(_vm.$store.state.match) ? _c('div', {
    staticClass: "content-layout"
  }, [_c('div', {
    staticClass: "column column__small"
  }, [_c('div', {
    staticClass: "block"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n                    Synsrapporter\n                ")]), _vm._v(" "), (_vm.$store.state.showingResult && !_vm.$store.state.loadingInspection && _vm.$store.state.carData.inspection !== null) ? _c('div', {
    staticClass: "body"
  }, [(_vm.$store.state.carData.inspection.Rapporter.length > 0) ? _c('div', {
    staticClass: "report-wrapper"
  }, [_vm._m(0), _vm._v(" "), _vm._l((_vm.sortedReports), function(report, index) {
    return _c('div', {
      staticClass: "single-report",
      class: {
        'active': _vm.activeReport === index, 'good': report.Synsresultat === 'Godkendt', 'neutral': report.Synsresultat !== 'Godkendt'
      },
      on: {
        "click": function($event) {
          _vm.activeReport = index
        }
      }
    }, [_c('div', {
      staticClass: "date"
    }, [_vm._v("\n                                " + _vm._s(_vm._f("moment")(report.SynsdatoFormateret, 'DD. MMM. YYYY')) + "\n                            ")]), _vm._v(" "), (report.Synsresultat === 'Godkendt') ? _c('div', {
      staticClass: "result good"
    }, [_vm._v("\n                                Godkendt\n                            ")]) : (report.Synsresultat === 'Middel') ? _c('div', {
      staticClass: "result neutral"
    }, [_vm._v("\n                                Middel\n                            ")]) : (report.Synsresultat === 'Betinget godkendt') ? _c('div', {
      staticClass: "result neutral"
    }, [_vm._v("\n                                Betinget godkendt\n                            ")]) : _c('div', {
      staticClass: "result neutral"
    }, [_vm._v("\n                                Kan godk. efter omsyn\n                            ")])])
  })], 2) : _c('div', [_vm._v("\n                        Køretøjet har endnu ikke været synet.\n                    ")])]) : _c('div', {
    staticClass: "body"
  }, [_vm._v("\n                    Ingen synsdata\n                ")])])]), _vm._v(" "), _c('div', {
    staticClass: "column column__large"
  }, [_vm._l((_vm.sortedReports), function(report, index) {
    return (_vm.activeReport !== null && _vm.activeReport === index && _vm.$store.state.carData.inspection) ? _c('div', {
      staticClass: "block animated fadeIn"
    }, [_c('div', {
      staticClass: "body"
    }, [_c('div', {
      staticClass: "active-report"
    }, [_c('div', {
      staticClass: "header"
    }, [(report.Synsresultat === 'Godkendt') ? _c('div', {
      staticClass: "result good"
    }, [_vm._v("\n                                " + _vm._s(report.Synsresultat) + "\n                            ")]) : _c('div', {
      staticClass: "result neutral"
    }, [_vm._v("\n                                " + _vm._s(report.Synsresultat) + "\n                            ")]), _vm._v(" "), _c('div', {
      staticClass: "company"
    }, [_c('b', [_vm._v(_vm._s(report.Firma))]), _vm._v(" "), _c('br'), _vm._v("\n                                " + _vm._s(report.Adresse) + "\n                                "), _c('br'), _vm._v("\n                                CVR: " + _vm._s(report.Cvr) + "        \n                            ")])]), _vm._v(" "), _c('div', {
      staticClass: "boxes"
    }, [_c('div', {
      staticClass: "box"
    }, [_c('div', {
      staticClass: "box__title"
    }, [_vm._v("\n                                    Synsdato\n                                ")]), _vm._v(" "), _c('div', {
      staticClass: "box__value"
    }, [_vm._v("\n                                    " + _vm._s(_vm._f("moment")(report.SynsdatoFormateret, 'D. MMMM YYYY')) + "\n                                ")])]), _vm._v(" "), _c('div', {
      staticClass: "box"
    }, [_c('div', {
      staticClass: "box__title"
    }, [_vm._v("\n                                    Synstype\n                                ")]), _vm._v(" "), _c('div', {
      staticClass: "box__value"
    }, [_vm._v("\n                                    " + _vm._s(report.Synstype) + "\n                                ")])]), _vm._v(" "), _c('div', {
      staticClass: "box"
    }, [_c('div', {
      staticClass: "box__title"
    }, [_vm._v("\n                                    Nummerplade\n                                ")]), _vm._v(" "), _c('div', {
      staticClass: "box__value"
    }, [_vm._v("\n                                    " + _vm._s(report.RegNr) + "\n                                ")])]), _vm._v(" "), _c('div', {
      staticClass: "box"
    }, [_c('div', {
      staticClass: "box__title"
    }, [_vm._v("\n                                    Kilometerstand\n                                ")]), _vm._v(" "), _c('div', {
      staticClass: "box__value"
    }, [_vm._v("\n                                    " + _vm._s(_vm._f("thousand")(report.Kmstand)) + " km\n                                ")])])]), _vm._v(" "), _c('hr'), _vm._v(" "), (report.Fejl) ? _c('div', {
      staticClass: "error-wrapper"
    }, [_c('div', {
      staticClass: "error__title"
    }, [_vm._v("\n                                Fejl (" + _vm._s(report.Fejl.length) + ")\n                            ")]), _vm._v(" "), (report.Fejl.length > 0) ? _c('div', {
      staticClass: "error-list"
    }, _vm._l((report.Fejl), function(error) {
      return _c('div', {
        staticClass: "error"
      }, [_c('b', [_vm._v(_vm._s(error.Number))]), _vm._v(" - " + _vm._s(error.Description) + "\n                                ")])
    }), 0) : _c('div', [_vm._v("\n                                Ingen fejl registreret.\n                            ")])]) : _vm._e()])])]) : _vm._e()
  }), _vm._v(" "), (_vm.activeReport === null) ? _c('div', {
    staticClass: "block"
  }, [_c('div', {
    staticClass: "body"
  }, [_vm._v("\n                    Vælg en synsrapport i menuen for at se hele rapportens detaljer her.\n                ")])]) : _vm._e()], 2)]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mobile-helper"
  }, [_vm._v("\n                            Vælg en synsrapport og scroll ned for at læse detaljerne\n                            "), _c('br'), _c('br')])
}]}

/***/ }),
/* 360 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "compare"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('br'), _c('br'), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.doSearch()
      }
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.licenseplate),
      expression: "licenseplate"
    }],
    attrs: {
      "type": "text",
      "placeholder": "Tilføj bil"
    },
    domProps: {
      "value": (_vm.licenseplate)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.licenseplate = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Tilføj")])]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), (_vm.vehicles.length > 0) ? _c('div', {
    staticClass: "compare-wrapper"
  }, [_c('div', {
    staticClass: "line"
  }, [_c('div', {
    staticClass: "line__meta"
  }), _vm._v(" "), _vm._l((_vm.vehicles), function(vehicle, index) {
    return _c('div', {
      staticClass: "line__value"
    }, [_c('a', {
      attrs: {
        "href": "javascript:void(0)"
      },
      on: {
        "click": function($event) {
          return _vm.removeVehicle(index)
        }
      }
    }, [_vm._v("Fjern")]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('b', [_vm._v(_vm._s(vehicle.general.MaerkeTypeNavn) + "\n                    " + _vm._s(vehicle.general.ModelTypeNavn))]), _vm._v(" "), _c('br'), _vm._v("\n                    " + _vm._s(vehicle.general.VariantTypeNavn) + "\n                ")])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "line"
  }, [_c('div', {
    staticClass: "line__meta"
  }, [_vm._v("\n                    Model årgang\n                ")]), _vm._v(" "), _vm._l((_vm.vehicles), function(vehicle) {
    return _c('div', {
      staticClass: "line__value"
    }, [_vm._v("\n                    " + _vm._s(vehicle.general.ModelAar) + "\n                ")])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "line"
  }, [_c('div', {
    staticClass: "line__meta"
  }, [_vm._v("\n                    Indregistreret\n                ")]), _vm._v(" "), _vm._l((_vm.vehicles), function(vehicle) {
    return _c('div', {
      staticClass: "line__value"
    }, [_vm._v("\n                    " + _vm._s(_vm._f("moment")(vehicle.general.FoersteRegistreringDato, 'D[.] MMMM YYYY')) + "\n                ")])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "line"
  }, [_c('div', {
    staticClass: "line__meta"
  }, [_vm._v("\n                    Motor\n                ")]), _vm._v(" "), _vm._l((_vm.vehicles), function(vehicle) {
    return _c('div', {
      staticClass: "line__value"
    }, [_vm._v("\n                    " + _vm._s(vehicle.general.MotorStoerrelse) + "L\n                    "), (vehicle.general.MotorCylinderAntal) ? _c('span', [_vm._v("(" + _vm._s(vehicle.general.MotorCylinderAntal) + " cyl.)")]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v("\n                    " + _vm._s(vehicle.general.DrivkraftTypeNavn) + "\n                ")])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "line"
  }, [_c('div', {
    staticClass: "line__meta"
  }, [_vm._v("\n                    Effekt\n                ")]), _vm._v(" "), _vm._l((_vm.vehicles), function(vehicle) {
    return _c('div', {
      staticClass: "line__value"
    }, [_vm._v("\n                    " + _vm._s(vehicle.general.MotorHestekraefter) + " HK\n                ")])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "line"
  }, [_c('div', {
    staticClass: "line__meta"
  }, [_vm._v("\n                    Max hastighed\n                ")]), _vm._v(" "), _vm._l((_vm.vehicles), function(vehicle) {
    return _c('div', {
      staticClass: "line__value"
    }, [(vehicle.general.MaksimumHastighed) ? _c('span', [_vm._v("\n                        " + _vm._s(vehicle.general.MaksimumHastighed) + " km/t\n                    ")]) : _c('span', [_vm._v("\n                        -\n                    ")])])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "line"
  }, [_c('div', {
    staticClass: "line__meta"
  }, [_vm._v("\n                    Egenvægt\n                ")]), _vm._v(" "), _vm._l((_vm.vehicles), function(vehicle) {
    return _c('div', {
      staticClass: "line__value"
    }, [(vehicle.general.EgenVaegt) ? _c('span', [_vm._v("\n                        " + _vm._s(vehicle.general.EgenVaegt) + " kg\n                    ")]) : _c('span', [_vm._v("\n                        -\n                    ")])])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "line"
  }, [_c('div', {
    staticClass: "line__meta"
  }, [_vm._v("\n                    Forbrug\n                ")]), _vm._v(" "), _vm._l((_vm.vehicles), function(vehicle) {
    return _c('div', {
      staticClass: "line__value"
    }, [_vm._v("\n                    " + _vm._s(vehicle.general.MotorKmPerLiter) + " km/l\n                ")])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "line"
  }, [_c('div', {
    staticClass: "line__meta"
  }, [_vm._v("\n                    Halvårlig afgift\n                ")]), _vm._v(" "), _vm._l((_vm.vehicles), function(vehicle) {
    return _c('div', {
      staticClass: "line__value"
    }, _vm._l((vehicle.dmr.Afgift.AfgiftDetaljer), function(afgift) {
      return (afgift.AfgiftType === 'Sum') ? _c('div', [_vm._v("\n                        " + _vm._s(afgift.Pris) + "\n                    ")]) : _vm._e()
    }), 0)
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "line"
  }, [_c('div', {
    staticClass: "line__meta"
  }), _vm._v(" "), _vm._l((_vm.vehicles), function(vehicle) {
    return _c('div', {
      staticClass: "line__value"
    })
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "line"
  }, [_c('div', {
    staticClass: "line__meta"
  }), _vm._v(" "), _vm._l((_vm.vehicles), function(vehicle) {
    return _c('div', {
      staticClass: "line__value"
    })
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "line"
  }, [_c('div', {
    staticClass: "line__meta"
  }), _vm._v(" "), _vm._l((_vm.vehicles), function(vehicle) {
    return _c('div', {
      staticClass: "line__value"
    })
  })], 2)]) : _vm._e()])])
},staticRenderFns: []}

/***/ }),
/* 361 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "footer"
  }, [_c('partners'), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [(_vm.showStatsCount > 4) ? _c('div', {
    staticClass: "stats content-layout"
  }, [_c('div', {
    staticClass: "lookups column column__xs"
  }, [_c('span', [_vm._v("\n                    " + _vm._s(_vm._f("thousand")(_vm.newTotalLookups)) + "\n                ")]), _vm._v("\n                søgn. i alt\n            ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "lookups column column__xs"
  }, [_c('span', [_vm._v("\n                    " + _vm._s(_vm._f("thousand")(_vm.newTotalVehicles)) + "\n                ")]), _vm._v("\n                køretøjer\n            ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "lookups column column__xs"
  }, [_c('span', [_vm._v("\n                    " + _vm._s(_vm._f("thousand")(_vm.newLookupsYesterday)) + "\n                ")]), _vm._v("\n                søgn. i går\n            ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "lookups column column__xs"
  }, [_c('span', [_vm._v("\n                    " + _vm._s(_vm._f("thousand")(_vm.newLookupsToday)) + "\n                ")]), _vm._v("\n                søgn. i dag\n            ")]), _vm._v(" "), _c('br'), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.showStatsCount > 9) ? _c('div', [_c('a', {
    attrs: {
      "href": "https://online.adservicemedia.dk/cgi-bin/click.pl?pid=33267&cid=7110&productGroup=Samlino",
      "target": "_blank",
      "rel": "noopener"
    }
  }, [_vm._v("\n                Lead\n            ")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "copyright"
  }, [_vm._m(0), _vm._v(" "), _c('hr', {
    staticStyle: {
      "opacity": ".15"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "copyright-line"
  }, [_vm._v("\n                2019 ©\n                "), _c('span', {
    on: {
      "click": function($event) {
        return _vm.showStats()
      }
    }
  }, [_vm._v("\n                    NrPladeTjek.dk\n                ")]), _vm._v("\n                  |  \n                Udviklet og drevet af "), _c('a', {
    attrs: {
      "href": "https://deveo.dk",
      "target": "_blank",
      "rel": "noopener"
    }
  }, [_vm._v("Deveo ApS")])]), _vm._v(" "), _c('div', {
    staticClass: "copyright-line mobile"
  }, [_vm._v("\n                2019 ©\n                "), _c('span', {
    on: {
      "click": function($event) {
        _vm.showStatsCount = _vm.showStatsCount + 1
      }
    }
  }, [_vm._v("\n                    NrPladeTjek.dk\n                ")]), _vm._v(" "), _c('br'), _c('br'), _vm._v("\n                Udviklet og drevet af "), _c('a', {
    attrs: {
      "href": "https://deveo.dk",
      "target": "_blank",
      "rel": "noopener"
    }
  }, [_vm._v("Deveo ApS")])])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "opacity": ".5"
    }
  }, [_vm._v("\n                NrPladeTjek.dk er ikke ansvarlige for fejl i de viste oplysninger, da alle oplysninger er hentet fra offentlige registre.\n                "), _c('br'), _c('br'), _vm._v(" "), _c('a', {
    attrs: {
      "href": "mailto:kontakt@nrpladetjek.dk"
    }
  }, [_vm._v("Kontakt os")]), _vm._v(" ved spørgsmål eller feedback om vores side.\n            ")])
}]}

/***/ }),
/* 362 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "search"
  }, [(_vm.image) ? _c('div', {
    staticClass: "car-image-wrapper",
    on: {
      "click": function($event) {
        _vm.image = null
      }
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.image
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "floating-top-banner-mobile animated fadeInDown delay-1s",
    on: {
      "click": function($event) {
        _vm.goToInsurancePartner('Samlino (mobile banner)')
      }
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/partners/samlino-mobile-banner2.jpg"
    }
  })]), _vm._v(" "), _c('top-menu'), _vm._v(" "), _c('div', {
    staticClass: "main-content"
  }, [_c('div', {
    staticClass: "container",
    staticStyle: {
      "position": "relative"
    }
  }, [(!_vm.$store.state.searching && _vm.$store.state.match) ? _c('div', {
    staticClass: "floating-partner animated fadeInLeft delay-5s floating-partner__left",
    on: {
      "click": function($event) {
        _vm.goToInsurancePartner('Samlino (banner)')
      }
    }
  }, [_vm._m(0)]) : _vm._e(), _vm._v(" "), (!_vm.$store.state.searching && _vm.$store.state.match) ? _c('div', {
    staticClass: "floating-partner animated fadeInRight delay-5s floating-partner__right",
    on: {
      "click": function($event) {
        _vm.goToBroadbandPartner('Fastspeed (banner)')
      }
    }
  }, [_vm._m(1)]) : _vm._e(), _vm._v(" "), (_vm.$store.state.match) ? _c('router-view', {
    staticClass: "animated fadeIn"
  }) : _vm._e(), _vm._v(" "), (!_vm.$store.state.searching && !_vm.$store.state.match) ? _c('div', {
    staticClass: "no-results"
  }, [_vm._v("\n                Vi fandt desværre ingen resultater på din søgning.\n                "), _c('br'), _c('br'), _vm._v("\n                Tjek venligst, at du har indtastet de korrekte oplysninger og prøv igen.\n                "), _c('br'), _c('br'), _vm._v("\n                Har du indtastet den korrekte nummerplade, er det muligt, at et af registrene ikke svarer.\n                "), _c('br'), _vm._v("\n                Vi beder dig derfor prøve igen senere og beklager ulejligheden.\n            ")]) : _vm._e(), _vm._v(" "), (_vm.$store.state.searching) ? _c('div', {
    staticClass: "loader-spinner"
  }, [(_vm.$store.state.searching) ? _c('div', {
    staticClass: "loader-wrapper"
  }, [_vm._m(2)]) : _vm._e()]) : _vm._e()], 1)]), _vm._v(" "), _c('foo')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "inner"
  }, [_c('img', {
    attrs: {
      "src": "/static/partners/samlino-high-banner.jpg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "inner"
  }, [_c('img', {
    attrs: {
      "src": "/static/partners/fastspeed_high_2.png"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "lds-ring"
  }, [_c('div'), _vm._v(" "), _c('div'), _vm._v(" "), _c('div'), _vm._v(" "), _c('div')])
}]}

/***/ }),
/* 363 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "timeline"
  }, [_c('div', {
    staticClass: "content-layout"
  }, [_c('div', {
    staticClass: "column column__large"
  }, [_c('div', {
    staticClass: "block"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n                    Tidslinje\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "body"
  }, [_vm._v("\n                    Her er der noget content\n                ")])])])])])
}]}

/***/ })
],[255]);


// WEBPACK FOOTER //
// static/js/app.3137a94c4571f3289fcf.js